<template>
  <div class="content main-container">
    <loading :isShow="loading" />
    <div class="body" v-if="!reload">
      <!--------------------------------------------------------------- 基础信息 --------------------------------------------------------------------->
      <Form ref="formInline" class="page-form" :model="formData" :rules="formDataValidate" :label-width="120">
        <div class="title1 clearfix">
          <FormItem label="录单类型" prop="isAbnormal" key="isAbnormal" v-if="this.editFlag == 'edit' && this.isAbnormal != 'anomaly' && !this.isDraft">
            <div>普通单</div>
          </FormItem>
          <FormItem label="录单类型" prop="isAbnormal" key="isAbnormal2" v-else>
            <RadioGroup v-model="formData.isAbnormal" @on-change="changeRadio">
              <Radio label="0">普通单</Radio>
              <Radio label="1">异常单</Radio>
            </RadioGroup>
            <Poptip trigger="hover" placement="bottom-start">
              <Icon type="ios-help-circle-outline" size="18" color="#000" style="margin-left: -6px; margin-top: 2px" />
              <div slot="content" style="color: #333">
                有问题的保单（如信息不全）又需要录入时，使用异常单录单。异常单无法统计业绩、无法结算、无法生成续期记录，请谨慎使用，请在需要的时候及时转存为普通单。
              </div>
            </Poptip>
          </FormItem>
          <Button class="back-btn" @click="backPage">返回</Button>
        </div>
        <FormItem label="异常原因" prop="cause" key="cause" class="two" v-if="formData.isAbnormal == '1'">
          <Input type="textarea" v-model="formData.cause" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="备注" prop="remark" key="remark" class="two">
          <Input type="textarea" v-model="formData.remark" placeholder="请输入" clearable />
        </FormItem>
        <div class="title">
          <div class="title-desc">出单信息</div>
        </div>
        <FormItem
          label="出单团队"
          prop="groupId"
          key="groupId"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择出单团队') : { required: false }"
        >
          <selectTree ref="selectTreeRef1" type="1" v-model="formData.groupId" @change="selectTreeChange" @getTreeData="getTreeData"></selectTree>
        </FormItem>
        <FormItem label="出单机构" prop="orgName" key="orgName">
          <Input type="text" v-model="formData.orgName" placeholder="选择团队或业务员后自动回显" disabled />
        </FormItem>
        <FormItem
          label="出单业务员"
          prop="salesmanId"
          key="salesmanId"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择出单业务员') : { required: false }"
        >
          <lzSelect
            v-model="formData.salesmanId"
            placeholder="请输入姓名或工号搜索"
            ref="salesmanSelect"
            :remote-method="getUserList"
            :transfer="true"
            @change="selectSalesMan"
          >
            <template slot-scope="{ list }">
              <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.staffNo ? item.name + '-' + item.staffNo : item.name">
                <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </template>
          </lzSelect>
        </FormItem>
        <FormItem label="协同人" prop="helpUserId" key="helpUserId">
          <lzSelect v-model="formData.helpUserId" placeholder="请输入姓名或工号搜索" :remote-method="getUserList" :transfer="true">
            <template slot-scope="{ list }">
              <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.staffNo ? item.name + '-' + item.staffNo : item.name">
                <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </template>
          </lzSelect>
        </FormItem>
        <FormItem label="保单号" prop="policyNo" key="policyNo">
          <Input type="text" v-model="formData.policyNo" placeholder="请输入" clearable :disabled="editFlag == 'edit' && !isDraft" />
        </FormItem>
        <FormItem label="投保单号" prop="proposalNo">
          <Input type="text" v-model="formData.proposalNo" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="保险公司" prop="companyCode" key="companyCode">
          <Select :label-in-value="true" transfer v-model="formData.companyCode" @on-change="selectCompany($event)" placeholder="请选择" filterable>
            <Option :value="companyItem.code" v-for="companyItem in companyList" :key="companyItem.code">{{ companyItem.fullName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="区域" prop="area" key="area">
          <span v-if="showAreaText">{{ formData.area }}</span>
          <Button type="primary" @click="openArea" style="margin-left: 10px" v-if="showAreaText">修改</Button>
          <Cascader
            v-else
            :data="regionsArr"
            v-model="formData.areaCode"
            filterable
            change-on-select
            @on-change="(value, selectedData) => inputChange(value, selectedData)"
          ></Cascader>
        </FormItem>
        <FormItem label="业务类别" prop="sellType" key="sellType">
          <Select v-model="formData.sellType" placeholder="请选择" clearable transfer>
            <Option value="1">网销</Option>
            <Option value="2">电销</Option>
            <Option value="3">经代</Option>
          </Select>
        </FormItem>
        <FormItem label="业务来源" prop="sellResource" key="sellResource" v-if="$units.superviseShowVal()">
          <Select v-model="formData.sellResource" placeholder="请选择" clearable transfer>
            <Option value="2">直营</Option>
            <Option value="1">分销</Option>
          </Select>
        </FormItem>
        <FormItem label="是否自保件" prop="isSelfHold" key="isSelfHold">
          <Select v-model="formData.isSelfHold" placeholder="请选择" clearable transfer>
            <Option value="0">非自保件</Option>
            <Option value="1">自保件</Option>
          </Select>
        </FormItem>
        <FormItem label="是否互保件" prop="isMutualHold" key="isMutualHold">
          <Select v-model="formData.isMutualHold" placeholder="请选择" clearable transfer>
            <Option value="0">非互保件</Option>
            <Option value="1">互保件</Option>
          </Select>
        </FormItem>
        <FormItem prop="doubleRecordStatus" label="双录状态" key="doubleRecordStatus">
          <lzDicSelect v-model="formData.doubleRecordStatus" dicType="DOUBLE_STATUS"></lzDicSelect>
        </FormItem>
        <FormItem label="回执回销状态" prop="receiptStatus" key="receiptStatus">
          <Select v-model="formData.receiptStatus" placeholder="请选择" transfer clearable @on-change="receiptStatusChange">
            <Option value="-1">无需回执</Option>
            <Option value="0">未回执</Option>
            <Option value="1">回执成功</Option>
            <Option value="2">回执失败</Option>
          </Select>
        </FormItem>
        <FormItem label="回访状态" prop="verifyStatus" key="verifyStatus">
          <Select v-model="formData.verifyStatus" placeholder="请选择" transfer clearable>
            <Option value="0">等待回访</Option>
            <Option value="1">回访成功</Option>
            <Option value="2">回访失败</Option>
            <Option value="3">无需回访</Option>
          </Select>
        </FormItem>
        <FormItem
          label="承保日期"
          prop="insureTime"
          key="insureTime"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择承保日期') : { required: false }"
        >
          <DatePicker type="date" :value="formData.insureTime" @on-change="changeTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem
          label="投保时间"
          prop="holdTime"
          key="holdTime"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择投保时间') : { required: false }"
        >
          <DatePicker
            type="datetime"
            :value="formData.holdTime"
            @on-change="formData.holdTime = $event"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem
          label="支付时间"
          prop="payTime"
          key="payTime"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择支付时间') : { required: false }"
        >
          <DatePicker
            type="datetime"
            :value="formData.payTime"
            @on-change="formData.payTime = $event"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem
          label="生效日期"
          prop="effectTime"
          key="effectTime"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择生效日期') : { required: false }"
        >
          <DatePicker
            type="date"
            :value="formData.effectTime"
            @on-change="formData.effectTime = $event"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="回执签收日期" prop="receiptDate2" key="receiptDate2">
          <DatePicker
            type="date"
            :value="formData.receiptDate2"
            @on-change="formData.receiptDate2 = $event"
            :disabled="formData.receiptStatus == -1"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="回执回销日期" prop="receiptDate" key="receiptDate">
          <DatePicker
            type="date"
            :value="formData.receiptDate"
            @on-change="formData.receiptDate = $event"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :disabled="formData.receiptStatus == -1"
          ></DatePicker>
        </FormItem>
        <FormItem label="回访日期" prop="verifyTime" key="verifyTime">
          <DatePicker
            type="date"
            :value="formData.verifyTime"
            @on-change="formData.verifyTime = $event"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="犹豫期截止日" prop="hesitateTime" key="hesitateTime">
          <DatePicker
            type="date"
            :value="formData.hesitateTime"
            @on-change="formData.hesitateTime = $event"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="终保日期" prop="endTime" key="endTime">
          <DatePicker type="date" :value="formData.endTime" @on-change="formData.endTime = $event" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem label="录单人员" prop="enterUserId" v-if="editFlag == 'edit'" key="enterUserId">
          {{ formData.enterUserName }}
        </FormItem>
        <FormItem label="服务代理人" prop="serviceAgent" key="serviceAgent">
          <lzSelect
            v-model="formData.serviceAgent"
            placeholder="请输入姓名或工号搜索"
            :remote-method="getOrgUserList"
            :transfer="true"
            :disabled="editFlag == 'edit'"
          >
            <template slot-scope="{ list }">
              <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.staffNo ? item.name + '-' + item.staffNo : item.name">
                <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </template>
          </lzSelect>
        </FormItem>
        <div class="title">
          <div class="title-desc">产品信息</div>
        </div>
        <FormItem label="主附险类型">
          <div>主险</div>
        </FormItem>
        <FormItem label="产品名称" prop="productCode" key="productCode">
          <Select
            ref="resetSelect"
            :label-in-value="true"
            v-model="formData.productCode"
            @on-change="selectProduct($event, formData)"
            placeholder="请选择"
            filterable
            clearable
            transfer
          >
            <Option :value="product.productCode" v-for="product in productListArr" :label="product.productCode + '/' + product.productName" :key="product.id">
              <Tag v-if="product.supplierName" color="blue">{{ product.supplierName }}</Tag>
              {{ product.productCode + '/' + product.productName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="档次/计划"
          v-if="gradeAdditionList && gradeAdditionList.length > 1"
          prop="gradeCode"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择档次/计划') : { required: false }"
        >
          <Select v-model="formData.gradeCode" transfer @on-change="selectGradeAddition()" placeholder="请选择" filterable>
            <Option :value="item.gradeCode" v-for="(item, i) in gradeAdditionList" :key="i">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="产品方案" v-if="formData.gradeCode" key="programId">
          <Select :label-in-value="true" v-model="formData.programId" transfer @on-change="selectGrade($event, formData, true)" placeholder="请选择" filterable>
            <Option :value="item.programId" v-for="(item, i) in gradeList" :key="i">{{ item.programName }}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="交费方式"
          prop="payType"
          key="payType"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择交费方式') : { required: false }"
        >
          <Select v-model="formData.payType" placeholder="请选择" clearable transfer>
            <Option value="1">年交</Option>
            <Option value="2">月交</Option>
            <Option value="3">季交</Option>
            <Option value="4">半年交</Option>
            <Option value="7">趸交</Option>
          </Select>
        </FormItem>
        <FormItem
          label="交费期限"
          prop="payLimit"
          key="payLimit"
          v-if="formData.payType != '7'"
          :rules="formData.isAbnormal == '0' ? payLimitvali(true, formData) : payLimitvali(false, formData)"
        >
          <Input key="payLimit1" v-model="formData.payLimit" :maxlength="3" type="text" placeholder="请输入数字 终身输106">
            <Select slot="append" v-model="formData.payment" placeholder="请选择" transfer style="width: 90px">
              <Option value="1">年</Option>
              <Option value="2">月</Option>
              <Option value="6">岁</Option>
            </Select>
          </Input>
        </FormItem>
        <FormItem
          label="保障期限"
          prop="guaranteeLimit"
          key="guaranteeLimit"
          :rules="formData.isAbnormal == '0' ? guaranteeLimitvali(true, formData) : guaranteeLimitvali(false, formData)"
        >
          <Input v-model="formData.guaranteeLimit" :disabled="formData.guaranteeType == '1'" placeholder="仅填写数字" :maxlength="3" type="text">
            <Select v-model="formData.guaranteeType" transfer @on-change="changeFormDataGuaranteeType" slot="append" style="width: 90px">
              <Option value="1">终身</Option>
              <Option value="2">周岁</Option>
              <Option value="3">年</Option>
              <!-- <Option value="4">月</Option> -->
              <Option value="5">天</Option>
            </Select>
          </Input>
        </FormItem>
        <FormItem label="保额(元)" prop="insuredAmount" key="insuredAmount" :rules="$units.formRule.number(false)">
          <Input type="text" v-model="formData.insuredAmount" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="是否含身故" prop="includingDeath" key="includingDeath">
          <Select v-model="formData.includingDeath" placeholder="请选择" clearable transfer>
            <Option value="0">不含身故</Option>
            <Option value="1">含身故</Option>
          </Select>
        </FormItem>
        <FormItem label="保单年度" prop="payNumber" key="payNumber">
          <div>{{ formData.payNumber }}</div>
        </FormItem>
        <FormItem label="保费(元)" prop="mainFee" key="mainFee">
          <Input type="text" v-model="formData.mainFee" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem
          label="保单状态"
          prop="status"
          key="status"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择保单状态') : { required: false }"
        >
          <Select v-model="formData.status" @on-change="changeStatus" placeholder="请选择" transfer>
            <Option value="1">已承保</Option>
            <Option value="0">已终止</Option>
            <Option value="2">已中止</Option>
            <Option value="-1">已退保</Option>
          </Select>
        </FormItem>
        <FormItem label="退保原因" prop="reason" key="reason" v-if="formData.status == '-1'">
          <Input type="textarea" v-model="formData.reason" :autosize="true" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="退保日期" prop="returnTime" key="returnTime" v-if="formData.status == '-1'">
          <DatePicker
            type="date"
            :value="formData.returnTime"
            @on-change="formData.returnTime = $event"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem
          label="退保保费(元)"
          prop="refundFee"
          key="refundFee"
          v-if="formData.status == '-1'"
          :rules="formData.isAbnormal == '0' ? $units.formRule.number() : $units.formRule.number(false)"
        >
          <Input type="text" v-model="formData.refundFee" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
      </Form>
      <!--------------------------------------------------------------- 附加险 --------------------------------------------------------------------->
      <div class="title" v-if="hasAddition">
        <div class="title-desc">附加险</div>
        <Button type="primary" ghost @click="handleAddition()">+ 新增</Button>
        <Button type="error" @click="handleRemoveAddition" v-if="formDynamic.additional.length > 0">- 删除</Button>
      </div>
      <template v-if="hasAddition">
        <Form
          :ref="`additionalForm${m}`"
          class="page-form"
          :class="{ 'bottom-25-border': formDynamic.additional.length > 1 }"
          :rules="additionRules"
          :model="form"
          v-for="(form, m) in formDynamic.additional"
          :key="m + 11"
          :label-width="120"
        >
          <FormItem label="产品名称" prop="productId" :key="m + 'productId2'">
            <Select v-model="form.productId" placeholder="请选择" @on-change="selectAdditionInfo($event, m, form)" :label-in-value="true" filterable transfer>
              <Option
                :value="additionInfo.productId"
                v-for="(additionInfo, aindex) in additionalList"
                :disabled="disabledAdditional.includes(additionInfo.productId)"
                :key="aindex + ' '"
                >{{ additionInfo.code + '/' + additionInfo.productName }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="产品方案" :key="m + 'programId'">
            <Select :label-in-value="true" v-model="form.programId" transfer @on-change="selectGrade($event, form, false)" placeholder="请选择" filterable>
              <Option :value="item.programId" v-for="(item, i) in additionGradeList" :key="i" v-show="item.gradeCode == form.gradeCode">{{
                item.programName
              }}</Option>
            </Select>
          </FormItem>
          <FormItem label="保费(元)" prop="fee" :key="m + 'fee2'">
            <Input type="text" v-model="form.fee" :maxlength="30" placeholder="请输入" clearable />
          </FormItem>
          <FormItem
            label="保单状态"
            prop="status"
            :key="m + 'status2'"
            :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择保单状态') : { required: false }"
          >
            <Select v-model="form.status" placeholder="请选择" transfer @on-change="changeStatus2(form)">
              <Option value="1">已承保</Option>
              <Option value="0">已终止</Option>
              <Option value="-1">已退保</Option>
            </Select>
          </FormItem>
          <FormItem label="退保原因" prop="reason" :key="m + 'reason2'" v-if="form.status == '-1'">
            <Input type="textarea" v-model="form.reason" :autosize="true" placeholder="请输入" clearable />
          </FormItem>
          <FormItem label="退保日期" prop="returnTime" :key="m + 'returnTime2'" v-if="form.status == '-1'">
            <DatePicker type="date" :value="form.returnTime" @on-change="form.returnTime = $event" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
          </FormItem>
          <FormItem
            label="退保保费(元)"
            prop="refundFee"
            :key="m + 'refundFee2'"
            v-if="form.status == '-1'"
            :rules="formData.isAbnormal == '0' ? $units.formRule.number() : $units.formRule.number(false)"
          >
            <Input type="text" v-model="form.refundFee" :maxlength="30" placeholder="请输入" clearable />
          </FormItem>
          <FormItem
            label="交费方式"
            prop="payType"
            :key="m + 'payType2'"
            :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择交费方式') : { required: false }"
          >
            <Select v-model="form.payType" placeholder="请选择" clearable transfer>
              <Option value="1">年交</Option>
              <Option value="2">月交</Option>
              <Option value="3">季交</Option>
              <Option value="4">半年交</Option>
              <Option value="7">趸交</Option>
            </Select>
          </FormItem>
          <FormItem
            label="交费期限"
            prop="payLimit"
            :key="m + 'payLimit'"
            v-if="form.payType != '7'"
            :rules="formData.isAbnormal == '0' ? payLimitvali(true, form) : payLimitvali(false, form)"
          >
            <Input type="text" v-model="form.payLimit" :maxlength="3" placeholder="仅填写数字">
              <Select slot="append" v-model="form.payment" placeholder="请选择" style="width: 90px" transfer>
                <Option value="1">年</Option>
                <Option value="2">月</Option>
                <Option value="6">岁</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem
            label="保障期限"
            prop="guaranteeLimit"
            :key="m + 'guaranteeLimit'"
            :rules="formData.isAbnormal == '0' ? guaranteeLimitvali(true, form) : guaranteeLimitvali(false, form)"
          >
            <Input v-model="form.guaranteeLimit" :disabled="form.guaranteeType == '1'" placeholder="仅填写数字" :maxlength="3" type="text">
              <Select v-model="form.guaranteeType" slot="append" style="width: 90px" transfer @on-change="guarantLimitSelect(form)">
                <Option value="1">终身</Option>
                <Option value="2">周岁</Option>
                <Option value="3">年</Option>
                <!-- <Option value="4">月</Option> -->
                <Option value="5">天</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem label="保单年度" prop="payNumber" :key="m + 'payNumber2'">
            <div>{{ form.payNumber }}</div>
          </FormItem>
          <FormItem label="保额(元)" prop="insuredAmount" :key="m + 'insuredAmount'" :rules="$units.formRule.number(false)">
            <Input type="text" v-model="form.insuredAmount" :maxlength="30" placeholder="请输入" clearable />
          </FormItem>
        </Form>
      </template>
      <!--------------------------------------------------------------- 投保人信息 --------------------------------------------------------------------->
      <div class="title">
        <div class="title-desc">投保人信息</div>
      </div>
      <Form ref="policyHoderref" class="page-form" :model="policyHoderForm" :rules="policyHoderValidate" :label-width="120">
        <FormItem
          label="投保人姓名"
          prop="holderName"
          key="holderName"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请输入投保人姓名') : { required: false }"
        >
          <Input
            class="policyNameInput"
            type="text"
            v-model="policyHoderForm.holderName"
            placeholder="请输入"
            clearable
            @on-change="changeHolderName(policyHoderForm.holderName)"
          />
          <Poptip popper-class="policyPoper" placement="bottom-start" width="600" trigger="click">
            <Button type="primary" @click="searchPolicyUserName(true)" style="vertical-align: top" icon="ios-search"></Button>
            <div class="api" slot="content">
              <loading :isShow="tableLoading" />
              <nameTable :data="policyNameArr" @rePolicyInfo="rePolicyInfo"></nameTable>
            </div>
          </Poptip>
        </FormItem>
        <FormItem
          label="投保人证件类型"
          prop="holderIdType"
          key="holderIdType"
          :label-width="130"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择投保人证件类型') : { required: false }"
        >
          <Select v-model="policyHoderForm.holderIdType" placeholder="请选择" @on-change="idcardChange($event, policyHoderForm, true)" transfer>
            <Option value="01">身份证</Option>
            <Option value="02">护照</Option>
            <Option value="03">军人证</Option>
            <Option value="06">户口本</Option>
            <Option value="04">出生证</Option>
            <Option value="99">其他</Option>
          </Select>
        </FormItem>
        <FormItem
          label="投保人证件号"
          prop="holderIdNo"
          key="holderIdNo"
          :label-width="120"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('投保人证件号不能为空') : { required: false }"
        >
          <div class="tips">
            <Input
              type="text"
              v-if="policyHoderForm.eyeShow1 || !idEye"
              v-model="policyHoderForm.holderIdNo"
              @on-change="idcardChange($event, policyHoderForm, true, 1)"
              placeholder="请输入"
              clearable
            />
            <Input
              type="text"
              v-else
              v-model="policyHoderForm.holderIdNo1"
              @on-change="idcardChange($event, policyHoderForm, true, 1)"
              placeholder="请输入"
              clearable
            />
            <span v-if="idEye && editFlag != 'copy' && policyHoderForm.holderIdNo1">
              <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow1" @click="openEye(policyHoderForm, 'eyeShow1', 'holderIdNo')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm, 'eyeShow1', 'holderIdNo')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="投保人性别" prop="holderSex" key="holderSex">
          <RadioGroup v-model="policyHoderForm.holderSex">
            <Radio label="1">男</Radio>
            <Radio label="2">女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="投保人出生日期" prop="holderBirth" key="holderBirth" :label-width="130">
          <DatePicker
            type="date"
            :value="policyHoderForm.holderBirth"
            @on-change="policyHoderForm.holderBirth = $event"
            format="yyyy-MM-dd"
            :options="dateOptions"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="投保人年收入(万元)" prop="holderIncome" key="holderIncome" :label-width="130" :rules="$units.formRule.number(false)">
          <Input type="text" v-model="policyHoderForm.holderIncome" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="投保人电话" prop="holderMobile" key="holderMobile" :rules="getRules('holderMobile')">
          <div class="tips">
            <Input
              type="text"
              v-if="policyHoderForm.eyeShow2 || !mobileEye"
              @on-change="mobileChange($event, 1, policyHoderForm)"
              v-model="policyHoderForm.holderMobile"
              placeholder="请输入"
              clearable
            />
            <Input
              type="text"
              v-else
              @on-change="mobileChange($event, 1, policyHoderForm)"
              v-model="policyHoderForm.holderMobile1"
              placeholder="请输入"
              clearable
            />
            <span v-if="mobileEye && editFlag != 'copy' && policyHoderForm.holderMobile1">
              <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow2" @click="openEye(policyHoderForm, 'eyeShow2', 'holderMobile')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm, 'eyeShow2', 'holderMobile')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem
          label="投保人邮箱"
          prop="holderEmail"
          key="holderEmail"
          :rules="oldEmail || emailEye ? { required: false, message: '请输入正确的邮箱地址' } : $units.formRule.email(false)"
        >
          <div class="tips">
            <AutoComplete
              v-if="policyHoderForm.eyeShow3 || !emailEye"
              @on-change="emailChange($event, 1, policyHoderForm)"
              v-model="policyHoderForm.holderEmail"
              :data="policyHoderForm.emailArr"
              @on-search="emailSearch($event, policyHoderForm)"
              placeholder="请输入"
            ></AutoComplete>
            <AutoComplete
              v-else
              v-model="policyHoderForm.holderEmail1"
              @on-change="emailChange($event, 1, policyHoderForm)"
              :data="policyHoderForm.emailArr"
              @on-search="emailSearch($event, policyHoderForm)"
              placeholder="请输入"
            ></AutoComplete>
            <span v-if="emailEye && editFlag != 'copy' && policyHoderForm.holderEmail1">
              <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow3" @click="openEye(policyHoderForm, 'eyeShow3', 'holderEmail')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm, 'eyeShow3', 'holderEmail')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="投保人职业" prop="holderJob" key="holderJob">
          <Input type="text" v-model="policyHoderForm.holderJob" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="身高(cm)" prop="height" key="height" :rules="$units.formRule.number(false)">
          <Input type="text" v-model="policyHoderForm.height" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="体重(kg)" prop="weight" key="weight" :rules="$units.formRule.number(false)">
          <Input type="text" v-model="policyHoderForm.weight" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="有无社保" prop="hasSocialInsurance" key="hasSocialInsurance">
          <Select v-model="policyHoderForm.hasSocialInsurance" placeholder="请选择" clearable transfer>
            <Option value="0">无社保</Option>
            <Option value="1">有社保</Option>
          </Select>
        </FormItem>
        <FormItem prop="familyRelationShip" label="家庭关系" key="familyRelationShip">
          <lzDicSelect v-model="policyHoderForm.familyRelationShip" dicType="MARITAL_STATUS"></lzDicSelect>
        </FormItem>
        <FormItem label="投保人证件有效期" prop="term" key="term" style="width: 33.3%" :label-width="130">
          <DatePicker
            v-if="policyHoderForm.lifelong"
            format="yyyy-MM-dd"
            type="date"
            :value="policyHoderForm.holderIdStartDate"
            @on-change="policyHoderForm.holderIdStartDate = $event"
            style="width: calc(100% - 65px)"
            placeholder="选择起始日期"
            clearable
          ></DatePicker>
          <DatePicker
            v-else
            format="yyyy-MM-dd"
            type="daterange"
            v-model="policyHoderForm.term"
            :split-panels="true"
            style="width: calc(100% - 65px)"
            placeholder="选择日期"
            clearable
            separator="至"
          ></DatePicker>
          <Checkbox v-model="policyHoderForm.lifelong" style="width: 50px; margin-left: 10px; margin-right: 0">长期</Checkbox>
        </FormItem>
        <FormItem prop="regionCode" label="联系地址" key="regionCode">
          <span v-if="policyHoderForm.showAreaText">{{ policyHoderForm.region }}</span>
          <Button type="primary" @click="openRegionCascader(policyHoderForm, 'regionCode')" style="margin-left: 10px" v-if="policyHoderForm.showAreaText"
            >修改</Button
          >
          <Cascader
            v-if="!policyHoderForm.showAreaText"
            :data="regionsArr2"
            v-model="policyHoderForm.regionCode"
            filterable
            :load-data="loadRegionsData"
            @on-change="(value, selectedData) => regionCascader(policyHoderForm, 'region', selectedData)"
          ></Cascader>
        </FormItem>
        <FormItem
          label="投保人详细地址"
          style="width: 66.6%"
          prop="holderAddress"
          key="holderAddress"
          :rules="
            oldAddress || addressEye
              ? { required: false, message: '请输入正确的地址' }
              : { required: false, validator: validateMessage, message: '请输入正确的地址', trigger: 'change' }
          "
        >
          <div class="tips">
            <Input
              type="textarea"
              @on-change="addressChange($event, 1, policyHoderForm)"
              v-if="policyHoderForm.eyeShow4 || !addressEye"
              v-model="policyHoderForm.holderAddress"
              placeholder="请输入"
              clearable
            />
            <Input
              type="textarea"
              @on-change="addressChange($event, 1, policyHoderForm)"
              v-else
              v-model="policyHoderForm.holderAddress1"
              placeholder="请输入"
              clearable
            />
            <span v-if="addressEye && editFlag != 'copy' && policyHoderForm.holderAddress1">
              <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow4" @click="openEye(policyHoderForm, 'eyeShow4', 'holderAddress')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm, 'eyeShow4', 'holderAddress')"></i>
            </span>
          </div>
        </FormItem>
      </Form>
      <!--------------------------------------------------------------- 被保险人信息 --------------------------------------------------------------------->
      <div class="title">
        <div class="title-desc">被保人信息</div>
        <Button type="primary" ghost @click="handleAddInsured()">+ 新增</Button>
        <Button type="error" v-if="insuredFormDynamic.insuredForm.length > 1" @click="handleDeleteInsured()">- 删除</Button>
      </div>
      <Form
        :ref="`insuredFormRef${ins}`"
        class="page-form"
        :class="{
          'bottom-25-border': insuredFormDynamic.insuredForm.length > 1
        }"
        :rules="insuredFormValidate"
        :model="insureds"
        v-for="(insureds, ins) in insuredFormDynamic.insuredForm"
        :key="`insuredFormRef${ins}`"
        :label-width="130"
      >
        <FormItem
          label="与投保人的关系"
          prop="holderRelation"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择与投保人的关系') : { required: false }"
        >
          <Select v-model="insureds.holderRelation" @on-change="insuredRelationChange(insureds, ins)" clearable transfer placeholder="请选择">
            <Option value="1">本人</Option>
            <Option value="2">父母</Option>
            <Option value="3">子女</Option>
            <Option value="4">配偶</Option>
            <Option value="30">孙子女</Option>
            <Option value="31">外孙子女</Option>
            <Option value="99">其他</Option>
          </Select>
        </FormItem>
        <FormItem
          label="被保人姓名"
          prop="name"
          :key="ins + 'name'"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('被保人姓名不能为空') : { required: false }"
        >
          <Input class="policyNameInput" type="text" :disabled="insureds.holderRelation == 1" v-model="insureds.name" placeholder="请输入" clearable />
          <Poptip popper-class="policyPoper" placement="bottom-start" width="600" trigger="click">
            <Button type="primary" @click="searchPolicyUserName(false, insureds)" icon="ios-search" style="vertical-align: top"></Button>
            <div class="api" slot="content">
              <loading :isShow="tableLoading1" />
              <nameTable :data="insuredNameArr" @rePolicyInfo="row => reInsuredInfo(row, insureds)"></nameTable>
            </div>
          </Poptip>
        </FormItem>
        <FormItem
          label="被保人证件类型"
          prop="idType"
          :key="ins + 'idType'"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择被保人证件类型') : { required: false }"
        >
          <Select
            v-model="insureds.idType"
            :disabled="insureds.holderRelation == 1"
            clearable
            placeholder="请选择"
            @on-change="idcardChange($event, insureds, false)"
            transfer
          >
            <Option value="01">身份证</Option>
            <Option value="02">护照</Option>
            <Option value="03">军人证</Option>
            <Option value="06">户口本</Option>
            <Option value="04">出生证</Option>
            <Option value="99">其他</Option>
          </Select>
        </FormItem>
        <FormItem
          label="被保人证件号"
          prop="idNo"
          :key="ins + 'idNo'"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('被保人证件号不能为空') : { required: false }"
        >
          <div class="tips">
            <Input
              type="text"
              v-if="insureds.eyeShow1 || insureds['idEye' + ins]"
              v-model="insureds.idNo"
              :disabled="insureds.holderRelation == 1"
              placeholder="请输入"
              @on-change="idcardChange($event, insureds, false, 2, ins)"
              clearable
            />
            <Input
              type="text"
              v-else
              v-model="insureds.idNo1"
              :disabled="insureds.holderRelation == 1"
              placeholder="请输入"
              @on-change="idcardChange($event, insureds, false, 2, ins)"
              clearable
            />
            <span v-if="!insureds['idEye' + ins] && editFlag != 'copy' && insureds.idNo1">
              <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow1" @click="openEye(insureds, 'eyeShow1', 'idNo', ins, 2)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds, 'eyeShow1', 'idNo', ins, 2)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="被保人性别" prop="sex" :key="ins + 'sex'">
          <RadioGroup v-model="insureds.sex">
            <Radio label="1" :disabled="insureds.holderRelation == 1">男</Radio>
            <Radio label="2" :disabled="insureds.holderRelation == 1">女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="被保人年收入(万元)" prop="income" :key="ins + 'income'">
          <Input type="text" v-model="insureds.income" :disabled="insureds.holderRelation == 1" placeholder="请输入" clearable />
        </FormItem>
        <FormItem
          label="被保人电话"
          prop="mobile"
          :key="ins + 'mobile'"
          :rules="insureds['oldMobile' + ins] || !insureds['mobileEye' + ins] ? { required: false } : $units.formRule.tel('请输入正确的手机号', false)"
        >
          <div class="tips">
            <Input
              type="text"
              @on-change="mobileChange($event, 2, insureds, ins)"
              v-if="insureds.eyeShow2 || insureds['mobileEye' + ins]"
              v-model="insureds.mobile"
              :disabled="insureds.holderRelation == 1"
              placeholder="请输入"
              clearable
            />
            <Input
              type="text"
              v-else
              @on-change="mobileChange($event, 2, insureds, ins)"
              v-model="insureds.mobile1"
              :disabled="insureds.holderRelation == 1"
              placeholder="请输入"
              clearable
            />
            <span v-if="!insureds['mobileEye' + ins] && editFlag != 'copy' && insureds.mobile1">
              <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow2" @click="openEye(insureds, 'eyeShow2', 'mobile', ins, 2)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds, 'eyeShow2', 'mobile', ins, 2)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="被保人出生日期" prop="birth" :key="ins + 'birth'">
          <DatePicker
            type="date"
            :value="insureds.birth"
            @on-change="birthChange(insureds, $event)"
            format="yyyy-MM-dd"
            :options="dateOptions"
            :disabled="insureds.holderRelation == 1"
            placeholder="选择日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="被保人年龄" prop="age" :key="ins + 'age'">
          <Input type="text" v-model="insureds.age" placeholder="请输入" clearable disabled />
        </FormItem>
        <FormItem label="被保人职业" prop="job" :key="ins + 'job'">
          <Input type="text" v-model="insureds.job" :disabled="insureds.holderRelation == 1" placeholder="请输入" clearable />
        </FormItem>
        <FormItem
          label="被保人邮箱"
          prop="email"
          :key="ins + 'email'"
          :rules="insureds['oldEmail' + ins] || !insureds['emailEye' + ins] ? { required: false } : $units.formRule.email(false)"
        >
          <div class="tips">
            <AutoComplete
              v-if="insureds.eyeShow3 || insureds['emailEye' + ins]"
              @on-change="emailChange($event, 2, insureds, ins)"
              v-model="insureds.email"
              :data="insureds.emailArr"
              :disabled="insureds.holderRelation == 1"
              @on-search="emailSearch($event, insureds)"
              placeholder="请输入"
            ></AutoComplete>
            <AutoComplete
              v-else
              v-model="insureds.email1"
              @on-change="emailChange($event, 2, insureds, ins)"
              :data="insureds.emailArr"
              :disabled="insureds.holderRelation == 1"
              @on-search="emailSearch($event, insureds)"
              placeholder="请输入"
            ></AutoComplete>
            <span v-if="!insureds['emailEye' + ins] && editFlag != 'copy' && insureds.email1">
              <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow3" @click="openEye(insureds, 'eyeShow3', 'email', ins, 2)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds, 'eyeShow3', 'email', ins, 2)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="身高(cm)" prop="height" :key="ins + 'height'" :rules="$units.formRule.number(false)">
          <Input type="text" v-model="insureds.height" :disabled="insureds.holderRelation == 1" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="体重(kg)" prop="weight" :key="ins + 'weight'" :rules="$units.formRule.number(false)">
          <Input type="text" v-model="insureds.weight" :disabled="insureds.holderRelation == 1" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="有无社保" prop="hasSocialInsurance" :key="ins + 'hasSocialInsurance'">
          <Select v-model="insureds.hasSocialInsurance" transfer placeholder="请选择" :disabled="insureds.holderRelation == 1" clearable>
            <Option value="0">无社保</Option>
            <Option value="1">有社保</Option>
          </Select>
        </FormItem>
        <FormItem prop="familyRelationShip" :key="ins + 'familyRelationShip'" label="家庭关系">
          <lzDicSelect v-model="insureds.familyRelationShip" dicType="MARITAL_STATUS" :disabled="insureds.holderRelation == 1"></lzDicSelect>
        </FormItem>
        <FormItem label="被保人证件有效期" class="certy-vali1" prop="term" :key="ins + 'term'">
          <DatePicker
            v-if="insureds.lifelong"
            :disabled="insureds.holderRelation == 1"
            format="yyyy-MM-dd"
            type="date"
            :value="insureds.cardStartDate"
            @on-change="insureds.cardStartDate = $event"
            style="width: calc(100% - 65px)"
            placeholder="选择起始日期"
          ></DatePicker>
          <DatePicker
            v-else
            :disabled="insureds.holderRelation == 1"
            format="yyyy-MM-dd"
            type="daterange"
            v-model="insureds.term"
            :split-panels="true"
            style="width: calc(100% - 65px)"
            placeholder="选择日期"
          ></DatePicker>
          <Checkbox v-model="insureds.lifelong" :disabled="insureds.holderRelation == 1" style="width: 50px; margin-left: 10px; margin-right: 0">长期</Checkbox>
        </FormItem>
        <FormItem prop="regionCode" :key="ins + 'regionCode'" label="联系地址">
          <span v-if="insureds.showAreaText">{{ insureds.region }}</span>
          <Button
            type="primary"
            @click="openRegionCascader(insureds, 'regionCode')"
            style="margin-left: 10px"
            v-if="insureds.showAreaText && insureds.holderRelation != 1"
            >修改</Button
          >
          <Cascader
            v-if="!insureds.showAreaText && insureds.holderRelation != 1"
            :data="regionsArr2"
            :disabled="insureds.holderRelation == 1"
            v-model="insureds.regionCode"
            filterable
            :load-data="loadRegionsData"
            @on-change="(value, selectedData) => regionCascader(insureds, 'region', selectedData)"
          ></Cascader>
        </FormItem>
        <FormItem
          label="被保人详细地址"
          prop="address"
          :key="ins + 'address'"
          class="two"
          :rules="
            insureds['oldAddress' + ins] || !insureds['addressEye' + ins]
              ? { required: false, message: '请输入正确的地址' }
              : { required: false, validator: validateMessage, message: '请输入正确的地址', trigger: 'change' }
          "
        >
          <div class="tips">
            <Input
              type="textarea"
              @on-change="addressChange($event, 2, insureds, ins)"
              v-if="insureds.eyeShow4 || insureds['addressEye' + ins]"
              v-model="insureds.address"
              :disabled="insureds.holderRelation == 1"
              placeholder="请输入"
              clearable
            />
            <Input
              type="textarea"
              @on-change="addressChange($event, 2, insureds, ins)"
              v-else
              v-model="insureds.address1"
              :disabled="insureds.holderRelation == 1"
              placeholder="请输入"
              clearable
            />
            <span v-if="!insureds['addressEye' + ins] && editFlag != 'copy' && insureds.address1">
              <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow4" @click="openEye(insureds, 'eyeShow4', 'address', ins, 2)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds, 'eyeShow4', 'address', ins, 2)"></i>
            </span>
          </div>
          <div style="margin-top: 10px">
            <Button type="primary" @click="addressSameAsPH(insureds)" ghost>地址同投保人</Button>
          </div>
        </FormItem>
        <Form
          :ref="`rightsRef${ins}${r}`"
          :rules="rightsValidate"
          :model="right"
          v-for="(right, r) in insureds.rights1"
          :key="`rights-${r}`"
          :label-width="130"
        >
          <FormItem label="权益名称" prop="name">
            <Input type="text" v-model="right.name" placeholder="请输入" clearable />
          </FormItem>
          <FormItem label="保障额度" prop="quota">
            <Input type="text" v-model="right.quota" placeholder="请输入" clearable />
          </FormItem>
          <FormItem :label-width="0">
            <Button type="primary" @click="handleAddRight(insureds.rights1)" ghost>+ 新增</Button>
            <Button
              type="error"
              style="margin-left: 10px"
              @click="handleDeleteRight(insureds.rights1)"
              v-if="insureds.rights1.length > 1 && r + 1 == insureds.rights1.length"
              >- 删除</Button
            >
          </FormItem>
          <FormItem label="保障内容" prop="content" class="two">
            <Input type="textarea" v-model="right.content" placeholder="请输入" clearable />
          </FormItem>
        </Form>
      </Form>
      <!--------------------------------------------------------------- 受益人信息 --------------------------------------------------------------------->
      <div class="title">
        <div class="title-desc">受益人信息</div>
        <Button type="primary" ghost v-if="beneficiaryType != '1'" @click="handleAddBenefit()">+ 新增</Button>
        <Button type="error" v-if="beneficiaryType != '1' && benefitFormDynamic.benefitForm.length > 1" @click="handleDeleteBenefit()">- 删除</Button>
        <Button type="primary" v-if="beneficiaryType == '2'" ghost class="tbbtn" @click="benefitSameAsPH">受益人同投保人</Button>
      </div>
      <Form
        :ref="`benefitFormRef${b}`"
        class="page-form"
        :class="{
          'bottom-25-border': benefitFormDynamic.benefitForm.length > 1
        }"
        :rules="benefitValidate"
        :model="benefit"
        v-for="(benefit, b) in benefitFormDynamic.benefitForm"
        :key="b + ' '"
        :label-width="130"
      >
        <FormItem label="受益人类型" prop="beneficiaryType" key="beneficiaryType" v-if="b == 0">
          <Select v-model="beneficiaryType" placeholder="请选择" transfer>
            <Option value="2">指定受益人</Option>
            <Option value="1">法定受益人</Option>
          </Select>
        </FormItem>
        <FormItem
          label="受益人姓名"
          prop="name"
          :key="b + 'name'"
          v-if="beneficiaryType == 2"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('受益人姓名不能为空') : { required: false }"
        >
          <Input type="text" v-model="benefit.name" placeholder="请输入" clearable />
        </FormItem>
        <FormItem
          label="受益人手机号"
          prop="mobile"
          :key="b + 'mobile'"
          v-if="beneficiaryType == 2"
          :rules="benefit['oldMobile' + b] || !benefit['mobileEye' + b] ? { required: false } : $units.formRule.tel('请输入正确的手机号', false)"
        >
          <div class="tips">
            <Input
              type="text"
              @on-change="mobileChange($event, 3, benefit, b)"
              v-if="benefit.eyeShow2 || benefit['mobileEye' + b]"
              v-model="benefit.mobile"
              placeholder="请输入"
              clearable
            />
            <Input type="text" v-else @on-change="mobileChange($event, 3, benefit, b)" v-model="benefit.mobile1" placeholder="请输入" clearable />
            <span v-if="!benefit['mobileEye' + b] && benefit.mobile && editFlag != 'copy'">
              <i class="iconfont iconxianshi eye-icon" v-if="benefit.eyeShow2" @click="openEye(benefit, 'eyeShow2', 'mobile', b, 3)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(benefit, 'eyeShow2', 'mobile', b, 3)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem
          label="邮箱"
          prop="email"
          :key="b + 'email'"
          v-if="beneficiaryType == 2"
          :rules="benefit['oldEmail' + b] || !benefit['emailEye' + b] ? { required: false } : $units.formRule.email(false)"
        >
          <div class="tips">
            <AutoComplete
              v-if="benefit.eyeShow3 || benefit['emailEye' + b]"
              @on-change="emailChange($event, 3, benefit, b)"
              v-model="benefit.email"
              :data="benefit.emailArr"
              @on-search="emailSearch($event, benefit)"
              placeholder="请输入"
            ></AutoComplete>
            <AutoComplete
              v-else
              @on-change="emailChange($event, 3, benefit, b)"
              v-model="benefit.email1"
              :data="benefit.emailArr"
              @on-search="emailSearch($event, benefit)"
              placeholder="请输入"
            ></AutoComplete>
            <span v-if="!benefit['emailEye' + b] && benefit.email && editFlag != 'copy'">
              <i class="iconfont iconxianshi eye-icon" v-if="benefit.eyeShow3" @click="openEye(benefit, 'eyeShow3', 'email', b, 3)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(benefit, 'eyeShow3', 'email', b, 3)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem
          label="与被保人的关系"
          prop="insuranceRelation"
          :key="b + 'insuranceRelation'"
          v-if="beneficiaryType == 2"
          :rules="formData.isAbnormal == '0' ? $units.formRule.required('请选择与被保人的关系') : { required: false }"
        >
          <Select v-model="benefit.insuranceRelation" placeholder="请选择" clearable transfer>
            <Option value="2">父母</Option>
            <Option value="3">子女</Option>
            <Option value="4">配偶</Option>
            <Option value="30">孙子女</Option>
            <Option value="31">外孙子女</Option>
            <Option value="99">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="受益人证件类型" prop="idType" :key="b + 'idType'" v-if="beneficiaryType == 2">
          <Select v-model="benefit.idType" placeholder="请选择" transfer clearable @on-change="idcardChange(benefit, false)">
            <Option value="01">身份证</Option>
            <Option value="02">护照</Option>
            <Option value="03">军人证</Option>
            <Option value="06">户口本</Option>
            <Option value="04">出生证</Option>
            <Option value="99">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="受益人证件号" prop="idNo" :key="b + 'idNo'" v-if="beneficiaryType == 2">
          <div class="tips">
            <Input
              type="text"
              v-if="benefit.eyeShow1 || benefit['idEye' + b]"
              v-model="benefit.idNo"
              placeholder="请输入"
              @on-change="idcardChange($event, benefit, false, 3, b)"
              clearable
            />
            <Input type="text" v-else v-model="benefit.idNo1" placeholder="请输入" @on-change="idcardChange($event, benefit, false, 3, b)" clearable />
            <span v-if="!benefit['idEye' + b] && benefit.idNo && editFlag != 'copy'">
              <i class="iconfont iconxianshi eye-icon" v-if="benefit.eyeShow1" @click="openEye(benefit, 'eyeShow1', 'idNo', b, 3)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(benefit, 'eyeShow1', 'idNo', b, 3)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="受益人性别" prop="sex" :key="b + 'sex'" v-if="beneficiaryType == 2">
          <RadioGroup v-model="benefit.sex">
            <Radio label="1">男</Radio>
            <Radio label="2">女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="受益人出生日期" :key="b + 'birth'" v-if="beneficiaryType == 2">
          <DatePicker
            type="date"
            format="yyyy-MM-dd"
            :value="benefit.birth"
            @on-change="benefit.birth = $event"
            :options="dateOptions"
            placeholder="选择日期"
            clearable
          ></DatePicker>
        </FormItem>
        <FormItem
          label="受益比例(%)"
          prop="benefitScale"
          :key="b + 'benefitScale'"
          v-if="beneficiaryType == 2"
          :rules="formData.isAbnormal == '0' ? $units.formRule.number100() : { required: false }"
        >
          <Input type="text" v-model="benefit.benefitScale" placeholder="请输入1-100的整数" clearable />
        </FormItem>
        <FormItem
          label="受益顺序"
          prop="benefitOrder"
          :key="b + 'benefitOrder'"
          v-if="beneficiaryType == 2"
          :rules="formData.isAbnormal == '0' ? $units.formRule.number100() : { required: false }"
        >
          <Input type="text" v-model="benefit.benefitOrder" placeholder="请输入1-100的整数" clearable />
        </FormItem>
      </Form>
      <!--------------------------------------------------------------- 账户信息 --------------------------------------------------------------------->
      <div class="title">
        <div class="title-desc">账户信息</div>
      </div>
      <Form ref="accountFormRef" class="page-form" :model="accountForm" :label-width="130">
        <FormItem label="银行卡户名" prop="cardNoName">
          <Input type="text" v-model="accountForm.cardNoName" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="银行账户" prop="account">
          <div class="tips">
            <Input
              type="text"
              v-if="accountForm.eyeShow1 || !accountEye"
              v-model="accountForm.account"
              placeholder="请输入"
              clearable
              @on-change="bankChange($event, accountForm)"
            />
            <Input type="text" v-else v-model="accountForm.account1" placeholder="请输入" clearable @on-change="bankChange($event, accountForm)" />
            <span v-if="accountEye && editFlag != 'copy' && accountForm.account1">
              <i class="iconfont iconxianshi eye-icon" v-if="accountForm.eyeShow1" @click="openEye(accountForm, 'eyeShow1', 'account')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(accountForm, 'eyeShow1', 'account')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="开户行" prop="bank">
          <Input type="text" v-model="accountForm.bank" placeholder="请输入" clearable />
        </FormItem>
      </Form>
      <!--------------------------------------------------------------- 影像资料 --------------------------------------------------------------------->
      <div class="title">
        <div class="title-desc">影像资料</div>
      </div>
      <div class="nav-second-tab">
        <div class="tab-body">
          <span v-for="(theme, i) in themeList" :class="i == themeActive ? 'active' : ''" :key="i + ' '" @click="themeClick(i)">{{ theme }}</span>
        </div>
      </div>
      <upload v-if="themeActive == 0" :imgArr="insuranceContractList" @handleSuccess="handleSuccess"></upload>
      <upload v-if="themeActive == 1" :imgArr="insuranceInfoList" @handleSuccess="handleSuccess"></upload>
      <upload v-if="themeActive == 2" :imgArr="customerNoticeList" @handleSuccess="handleSuccess"></upload>
      <upload v-if="themeActive == 3" :imgArr="otherInfoList" @handleSuccess="handleSuccess"></upload>
      <div class="footerbtn" v-if="isDraft">
        <Button type="primary" class="qxbtn" @click="backPage" ghost>取消</Button>
        <Button type="primary" @click="addPolicy(true)" class="qrbtn">确认</Button>
        <Button type="warning" @click="addPolicy(false)" class="qrbtn">存为正式保单</Button>
      </div>
      <div class="footerbtn" v-else>
        <Button type="primary" class="qxbtn" @click="backPage" ghost>取消</Button>
        <Button type="primary" @click="addPolicy(false)" class="qrbtn">确认</Button>
        <Button type="warning" @click="addPolicy(true)" class="qrbtn" v-if="editFlag == 'add'">存草稿</Button>
      </div>
    </div>
  </div>
</template>
<script>
import selectTree from '@/components/system/selectTree3';
import areaTree from '@/components/commons/selectTree';
import upload from './components/upload';
import nameTable from './components/nameTable';
import lzDicSelect from '@/components/commons/lzDicSelect';
import lzSelect from '@/components/commons/lzSelect';
import { editData } from './form/editMixin';
import { mapState } from 'vuex';
import { common } from '@/api/mixins';

const dayjs = require('dayjs');
const duration = require('dayjs/plugin/duration');
dayjs.extend(duration);
export default {
  mixins: [editData, common],
  data() {
    return {
      // 投保人隐私信息
      mobileEye: true,
      idEye: true,
      emailEye: true,
      cardNoEye: true,
      addressEye: true,
      accountEye: true,
      oldMobile: '',
      oldIdNo: '',
      oldEmail: '',
      oldCardNo: '',
      oldAddress: '',
      productInfo: {}
    };
  },
  name: 'insureOrder.addPolicy',
  components: {
    lzSelect,
    lzDicSelect,
    selectTree,
    areaTree,
    upload,
    nameTable
  },
  computed: {
    ...mapState(['userInfo']),
    setHesitateTime() {
      return [
        this.formData.effectTime,
        this.formData.receiptDate,
        this.formData.companyCode,
        this.formData.productCode,
        this.productInfo.hesitateType,
        this.productInfo.hesitateTime
      ];
    }
  },
  watch: {
    setHesitateTime: _.debounce(function() {
      const receiptDate = this.formData.receiptDate; // 回执日期
      const hesitateTime = this.formData.hesitateTime; // 犹豫期截止日期
      const effectTime = this.formData.effectTime; // 生效日期
      const day = this.productInfo.hesitateTime;
      const tDay = typeof Number(day);
      const hesitateType = this.productInfo.hesitateType;
      if (!hesitateType) {
        console.warn('缺少犹豫期类型，所以不计算犹豫期日期');
        return;
      }
      console.log('tDay', tDay)
      if (tDay !== 'number' || isNaN(day)) {
        console.warn('犹豫期天数填写不正确，请检查');
        return;
      }
      if (!hesitateTime) {
        let time = null;
        if (hesitateType == 1 && receiptDate) {
          // 回执当日起
          time = dayjs(receiptDate).add(day - 1, 'day');
        } else if (hesitateType == 2 && receiptDate) {
          // 回执次日起
          time = dayjs(receiptDate).add(day - 1 + 1, 'day');
        } else if (hesitateType == 3 && effectTime) {
          // 生效日期起
          time = dayjs(effectTime).add(day - 1, 'day');
        }
        time && this.$set(this.formData, 'hesitateTime', time.format('YYYY-MM-DD'));
      }
    }, 500),
    'policyHoderForm.lifelong': {
      // 选终身时，日期置空
      handler() {
        if (this.policyHoderForm.lifelong) {
          this.policyHoderForm.term = '';
        } else {
          this.policyHoderForm.holderIdStartDate = '';
        }
      }
    },
    // 附加险名称列表
    additionalList: {
      handler() {
        if (this.additionalList.length > 0) {
          this.hasAddition = true;
        } else {
          this.hasAddition = false;
        }
      }
    }
  },
  activated() {
    if (this.editFlag == 'edit' && this.isAbnormal != 'anomaly' && !this.isDraft) {
      this.formData.isAbnormal = '0';
    }
    if (sessionStorage.reloadPolicyData == '1' && JSON.stringify(this.formDataBak) != '{}') {
      this.additionalList = [];
      this.formData = JSON.parse(JSON.stringify(this.formDataBak));
      this.policyHoderForm = JSON.parse(JSON.stringify(this.policyHoderFormBak));
      this.insuredFormDynamic = JSON.parse(JSON.stringify(this.insuredFormDynamicBak));
      this.benefitFormDynamic = JSON.parse(JSON.stringify(this.benefitFormDynamicBak));
      this.formDynamic = JSON.parse(JSON.stringify(this.formDynamicBak));
      this.beneficiaryType = '1';
      this.accountForm = {
        bank: '', //开户行
        cardNoName: '', //户名
        account: '' //银行账户
      };
      this.insuranceInfoList = []; //投保资料列表
      this.insuranceContractList = []; // 保险合同列表
      this.customerNoticeList = []; //客户告知书列表
      this.otherInfoList = []; //其他资料列表
      sessionStorage.reloadPolicyData = '0';
      this.clearMessage();
    }
    this.getCompanyList();
    this.getRegion();
    this.getDiabledAddition();
    this.$refs.selectTreeRef1 && this.$refs.selectTreeRef1.openChange(true);
  },
  created() {
    this.editFlag = this.$route.query.pageFlag;
    this.isDraft = this.$route.query.isDraft == 1;
    this.draftId = this.$route.query.draftId;
    if (this.editFlag == 'edit' || this.editFlag == 'copy') {
      let policyNo = this.$route.query.policyNo;
      let id = this.$route.query.id;
      this.isAbnormal = this.$route.query.type;
      this.getPolicyDetail(policyNo, id, this.isAbnormal);
    } else {
      this.getProductList();
      this.formDataBak = JSON.parse(JSON.stringify(this.formData));
      this.policyHoderFormBak = JSON.parse(JSON.stringify(this.policyHoderForm));
      this.insuredFormDynamicBak = JSON.parse(JSON.stringify(this.insuredFormDynamic));
      this.benefitFormDynamicBak = JSON.parse(JSON.stringify(this.benefitFormDynamic));
      this.formDynamicBak = JSON.parse(JSON.stringify(this.formDynamic));
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        this.$refs.selectTreeRef1 && this.$refs.selectTreeRef1.openChange();
      });
    }
  },
  methods: {
    validateMessage(rule, value, callback) {
      if (value && value.indexOf('*') != -1) {
        callback(new Error('请输入正确的格式'));
      }
      callback();
    },
    addressChange(e, val, data, b) {
      if (val == 1) {
        this.oldAddress = '';
        this.addressEye = false;
        this.$set(data, 'holderAddress', e.target.value);
        this.insuredFormDynamic.insuredForm.forEach((item, index) => {
          if (item.holderRelation == 1) {
            item.address = e.target.value;
            item['addressEye' + index] = true;
          }
        });
      } else if (val == 2) {
        data['oldAddress' + b] = '';
        data['addressEye' + b] = true;
        this.$set(data, 'address', e.target.value);
      }
    },
    emailChange(e, val, data, b) {
      if (val == 1) {
        this.oldEmail = '';
        this.$set(data, 'holderEmail', e);
        this.emailEye = false;
        this.insuredFormDynamic.insuredForm.forEach((item, index) => {
          if (item.holderRelation == 1) {
            item.email = e;
            item['emailEye' + index] = true;
          }
        });
      } else if (val == 2) {
        data['oldEmail' + b] = '';
        this.$set(data, 'email', e);
        data['emailEye' + b] = true;
      } else if (val == 3) {
        data['emailEye' + b] = true;
        this.$set(data, 'email', e);
        data['oldEmail' + b] = '';
      }
    },
    // 手机号修改
    mobileChange(e, val, data, b) {
      if (val == 1) {
        this.oldMobile = '';
        this.$set(data, 'holderMobile', e.target.value);
        this.mobileEye = false;
        this.insuredFormDynamic.insuredForm.forEach((item, index) => {
          if (item.holderRelation == 1) {
            item.mobile = e.target.value;
            item['mobileEye' + index] = true;
          }
        });
      } else if (val == 2) {
        data['oldMobile' + b] = '';
        this.$set(data, 'mobile', e.target.value);
        data['mobileEye' + b] = true;
      } else if (val == 3) {
        data['mobileEye' + b] = true;
        this.$set(data, 'mobile', e.target.value);
        data['oldMobile' + b] = '';
      }
    },
    getRules(item) {
      if (item == 'holderMobile') {
        if (this.formData.isAbnormal == '0') {
          if (this.oldMobile || this.mobileEye) {
            return { required: true, message: '请输入正确的手机号' };
          } else {
            return this.$units.formRule.tel('请输入正确的手机号', true);
          }
        } else {
          return this.$units.formRule.tel('请输入正确的手机号', false);
        }
      }
    },
    openEye(item, keyName, name, index, type) {
      let query, operationType, otherInfo, operationFunction;
      if (index >= 0) {
        otherInfo = {
          type: type,
          index: index
        };
      } else {
        otherInfo = {
          type: 1
        };
      }
      console.log(item);
      if (this.policyType == 'anomaly') {
        query = this.id;
        operationFunction = 16;
      } else {
        query = item.orderNo;
        operationFunction = 15;
      }
      if (name == 'holderMobile' || name == 'mobile') {
        operationType = 2;
      } else if (name == 'holderIdNo' || name == 'idNo') {
        operationType = 1;
      } else if (name == 'holderAddress' || name == 'address') {
        operationType = 5;
      } else if (name == 'holderEmail' || name == 'email') {
        operationType = 4;
      } else if (name == 'account') {
        operationType = 3;
      }
      if (!item[keyName]) {
        this.descrypt(
          {
            query: query,
            operationFunction: operationFunction,
            operationType: operationType,
            otherInfo: otherInfo
          },
          item,
          name,
          'order_30_10'
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    // 计算犹豫期时间
    // getHesitateTime() {
    //   const day = this.productInfo.hesitateTime;
    //   const hesitateType = this.productInfo.hesitateType;
    //   // 不存在犹豫期规则时不计算
    //   if (isNaN(day) || !hesitateType) {
    //     return;
    //   }
    //   const receiptDate = this.formData.receiptDate; // 回执日期
    //   const hesitateTime = this.formData.hesitateTime; // 犹豫期截止日期
    //   const effectTime = this.formData.effectTime; // 生效日期
    //   if (!hesitateTime) {
    //     let time;
    //     if (!hesitateType) {
    //       console.warn('缺少犹豫期类型，所以不计算犹豫期日期')
    //     }
    //     if (hesitateType == 1 && receiptDate) {
    //       // 回执当日起
    //       time = dayjs(receiptDate).add(day - 1, 'day');
    //     } else if (hesitateType == 2 && receiptDate) {
    //       // 回执次日起
    //       time = dayjs(receiptDate).add(day - 1 + 1 , 'day');
    //     } else if (hesitateType == 3 && effectTime) {
    //       // 生效日期起
    //       time = dayjs(effectTime).add(day - 1, 'day');
    //     }
    //     time && this.$set(this.formData, 'hesitateTime', time.format('YYYY-MM-DD'));
    //   }
    // },
    // 校验交费期限
    payLimitvali(required = true, formData) {
      return {
        validator: (rule, value, callback) => {
          if (this.formData.isAbnormal == '0') {
            if (!Number(formData.payLimit)) {
              callback(new Error('输入的类型为数字'));
            } else if (!formData.payment) {
              callback(new Error('请选择交费期限类型(年，月，岁)'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        required: required,
        trigger: 'change'
      };
    },
    // 校验保障期限
    guaranteeLimitvali(required = true, formData) {
      return {
        validator: (rule, value, callback) => {
          if (this.formData.isAbnormal == '0') {
            if (!Number(formData.guaranteeLimit)) {
              callback(new Error('输入的类型为数字'));
            } else if (!formData.guaranteeType) {
              callback(new Error('请选择保障类型（保天，保年，保岁，保终身)'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        required: required,
        trigger: 'change'
      };
    },
    // 获取当前机构业务员
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {
        orgId: this.userInfo.organId,
        isValid: 1
      };
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else if (keyword.includes('-')) {
        return;
      } else {
        params.userName = keyword;
      }
      return this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 获取服务代理人
    getOrgUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {
        orgId: this.userInfo.organId
      };
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else if (keyword.includes('-')) {
        return;
      } else {
        params.userName = keyword;
      }
      return this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 获取树节点id
    getTreeData(data) {
      this.depData(data);
    },
    depData(data) {
      data.forEach(item => {
        if (!item.orgId) {
          this.$set(item, 'disabled', true);
        }
        item.children.length ? this.depData(item.children) : [];
      });
    },
    // 正常单异常单切换
    changeRadio() {
      this.clearMessage();
    },
    // 投保时间和支付时间没有填的默认显示承保日期
    changeTime(value) {
      this.formData.insureTime = value;
      if (!this.formData.holdTime) {
        this.formData.holdTime = value + ' 00:00';
      }
      if (!this.formData.payTime) {
        this.formData.payTime = value + ' 00:00';
      }
    },
    backPage() {
      if (this.$route.query.workName == 'workName') {
        this.back('/workbench/index');
      } else {
        if (this.isDraft) {
          this.back('/orderManage/insuredOrder/draftList');
        } else {
          this.back('/orderManage/insuredOrder/main');
        }
      }
    },
    // 机构树选择
    selectTreeChange(data) {
      // 判断业务员当前出单组织是否与实际相符，如果不相符则清空
      const userList = this.$refs.salesmanSelect.list;
      const bean = userList.find(item => {
        return item.id == this.formData.salesmanId;
      });
      if (bean && bean.groupId != this.formData.groupId) {
        this.formData.salesmanId = '';
      }
      this.formData.orgName = data.orgName;
      this.formData.groupId = data.id;
      this.formData.orgId = data.orgId;
    },
    clearMessage() {
      // 基础信息
      this.$refs.formInline.fields.forEach(item => {
        item.validateState = '';
        item.validateMessage = '';
      });
      // 投保人
      this.$refs.policyHoderref.fields.forEach(item => {
        item.validateState = '';
        item.validateMessage = '';
      });
      // 附加险
      for (let i = 0; i < this.formDynamic.additional.length; i++) {
        this.$refs[`additionalForm${i}`][0].fields.forEach(item => {
          item.validateState = '';
          item.validateMessage = '';
        });
      }
      // 被保人
      for (let i = 0; i < this.insuredFormDynamic.insuredForm.length; i++) {
        this.$refs[`insuredFormRef${i}`][0].fields.forEach(item => {
          item.validateState = '';
          item.validateMessage = '';
        });
      }
      // 受益人
      for (let i = 0; i < this.benefitFormDynamic.benefitForm.length; i++) {
        this.$refs[`benefitFormRef${i}`][0].fields.forEach(item => {
          item.validateState = '';
          item.validateMessage = '';
        });
      }
    },
    getRegion() {
      this.$http({
        url: '/json/regionCascader.json',
        type: 'GET',
        forced: true,
        data: {}
      }).then(region => {
        const regionsArr = JSON.parse(JSON.stringify(region));
        regionsArr.forEach(item => {
          item.children.forEach(item2 => {
            delete item2.children;
          });
        });
        this.regionsArr = regionsArr; //省市
        this.regionsAll = [];
        this.setAllRegions(region);
        this.regionsArr2 = region.map(item => {
          return {
            ...item,
            children: '',
            loading: false
          };
        });
      });
    },
    // 扁平化数据
    setAllRegions(list) {
      list.forEach(item => {
        this.regionsAll.push(item);
        if (item.children && item.children.length) {
          this.setAllRegions(item.children);
        }
      });
    },
    loadRegionsData(item, callback) {
      const data = this.regionsAll.find(bean => {
        return item.value == bean.value;
      });
      if (data && data.children) {
        item.children = data.children;
      }
      callback();
    },
    changeFormDataGuaranteeType(val) {
      // 终身 106
      if (val == 1) {
        this.formData.guaranteeLimit = '106';
      }
    },
    // 区域
    inputChange(val, selectedData) {
      this.formData.area = selectedData.map(item => item.label).join('');
    },
    // 查询商户所有保司
    getCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    //被保险人关系更改时回填
    insuredRelationChange(insureds, ins) {
      // 被保险人选项，选择与投保人关系，为本人时，信息回填。
      insureds['mobileEye' + ins] = true;
      insureds['idEye' + ins] = true;
      insureds['emailEye' + ins] = true;
      insureds['addressEye' + ins] = true;
      if (insureds.holderRelation == 1) {
        insureds.name = this.policyHoderForm.holderName;
        insureds.idType = this.policyHoderForm.holderIdType; // 被保险人证件类型
        insureds.sex = this.policyHoderForm.holderSex; //被保险人性别
        insureds.income = this.policyHoderForm.holderIncome; //被保险人年收入
        insureds.birth = this.policyHoderForm.holderBirth; // 被保险人出生日期
        insureds.job = this.policyHoderForm.holderJob; // 被保险人职业
        insureds.term = this.policyHoderForm.term; // 有效期
        insureds.orderNo = this.policyHoderForm.orderNo; // 订单号
        insureds.cardStartDate = this.policyHoderForm.holderIdStartDate; // 有效期
        insureds.lifelong = this.policyHoderForm.lifelong; // 有效期-终身
        insureds.region = this.policyHoderForm.region; //联系地址
        insureds.regionCode = this.policyHoderForm.regionCode; //联系地址code
        insureds.height = this.policyHoderForm.height; //身高
        insureds.weight = this.policyHoderForm.weight; //体重
        insureds.hasSocialInsurance = this.policyHoderForm.hasSocialInsurance; //有无社保
        insureds.familyRelationShip = this.policyHoderForm.familyRelationShip; //家庭关系
        this.idcardChange(insureds, false);
        this.$http({
          url: '/buz/permissionLog/descrypt',
          type: 'post',
          data: {
            query: this.formData.policyNo,
            operationFunction: 0
          }
        }).then(res => {
          if (res.data.otherInfo) {
            let otherInfo = res.data.otherInfo;
            insureds.mobile = otherInfo.holderMobile;
            insureds.email = otherInfo.holderEmail;
            insureds.address = otherInfo.holderAddress;
            insureds.idNo = otherInfo.holderIdNo;
          } else {
            insureds.mobile = this.policyHoderForm.holderMobile;
            insureds.email = this.policyHoderForm.holderEmail;
            insureds.address = this.policyHoderForm.holderAddress;
            insureds.idNo = this.policyHoderForm.holderIdNo;
          }
        });
      }
      // else {
      //   this.$refs[`insuredFormRef${ins}`][0]&&this.$refs[`insuredFormRef${ins}`][0].resetFields()
      // }
    },
    // 投保人信息搜索
    searchPolicyUserName(isHolder, insureds) {
      let params = {
        pageSize: 20,
        pageNo: 1
      };
      if (isHolder) {
        params.name = this.policyHoderForm.holderName;
        this.tableLoading = true;
      } else {
        this.tableLoading1 = true;
        params.name = insureds.name;
      }
      this.$http({
        url: '/buz/customerBase/policyCustomerInfos',
        type: 'post',
        data: params
      })
        .then(res => {
          if (isHolder) {
            this.policyNameArr = res.data;
            this.tableLoading = false;
          } else {
            this.insuredNameArr = res.data;
            this.tableLoading1 = false;
          }
        })
        .catch(e => {
          if (isHolder) {
            this.tableLoading = false;
          } else {
            this.tableLoading1 = false;
          }
        });
    },
    changeHolderName(val) {
      this.accountForm = {
        cardNoName: val
      };
    },
    // 回填投保人信息
    rePolicyInfo(row) {
      this.idEye = false;
      this.mobileEye = false;
      this.emailEye = false;
      const data = {
        holderId: this.policyHoderForm.holderId,
        holderName: row.name,
        holderIdType: row.idType,
        holderIdNo: row.cardNo3,
        holderMobile: row.mobile,
        holderEmail: row.email,
        lifelong: false,
        term: [],
        holderSex: row.sex,
        holderIncome: row.income || '',
        holderJob: row.profession || '',
        holderBirth: row.birthDay || '',
        holderAddress: row.address || '',
        regionCode: row.regionCode || [],
        height: row.height || '',
        weight: row.weight || '',
        hasSocialInsurance: row.hasSocialInsurance || ''
      };
      if (row.isLong == 1) {
        data.lifelong = true;
        data.holderIdStartDate = row.cardStartDate || '';
      } else {
        data.lifelong = false;
      }
      if (row.cardStartDate && row.cardEndDate) {
        data.term = [row.cardStartDate, row.cardEndDate];
      }
      this.policyHoderForm = data;
      if (row.bankCardName == '') {
        this.accountForm = {
          cardNoName: row.name
        };
      } else {
        this.accountForm = {
          bank: row.bank,
          account: row.bankCardNo,
          cardNoName: row.bankCardName
        };
      }
    },
    // 回填被保险人信息
    reInsuredInfo(row, insureds) {
      insureds.name = row.name;
      insureds.idType = row.idType;
      insureds.idNo = row.cardNo3;
      insureds.idNo1 = row.cardNo3;
      insureds.sex = row.sex;
      insureds.birth = row.birthDay || '';
      insureds.income = row.income;
      insureds.mobile = row.mobile;
      insureds.mobile1 = row.mobile;
      insureds.email = row.email;
      insureds.email1 = row.email;
      insureds.job = row.profession;
      insureds.orderNo = row.orderNo;
      insureds.regionCode = row.regionCode || [];
      insureds.address = row.address;
      insureds.height = row.height || '';
      insureds.weight = row.weight || '';
      insureds.hasSocialInsurance = row.hasSocialInsurance;
      if (row.isLong == 1) {
        insureds.lifelong = true;
        data.cardStartDate = row.cardStartDate || '';
      } else {
        insureds.lifelong = false;
      }
      if (row.cardStartDate && row.cardEndDate) {
        insureds.term = [row.cardStartDate, row.cardEndDate];
      }
      this.idcardChange(insureds, false);
    },
    //选终身保障期限为空
    guarantLimitSelect(form) {
      if (form.guaranteeType == 1) {
        form.guaranteeLimit = '106';
      }
    },
    // 选择产品
    selectProduct(val, formData) {
      if (!val) {
        return;
      }
      if (val.label) {
        formData.programId = '';
        formData.programName = '';
        formData.gradeCode = '';

        this.productListArr.map(item => {
          if (item && item.productCode == val.value) {
            console.log('选择产品', JSON.parse(JSON.stringify(item)));
            if (this.formData.companyCode) {
              if (this.formData.companyCode != item.companyCode) {
                this.formData.companyCode = item.companyCode;
              }
            } else {
              this.formData.companyCode = item.companyCode;
            }
            this.productInfo = item;
            // 产品名称
            this.formData.productName = item.productName;
            // 产品来源
            this.formData.source = item.source;
            // 产品id
            this.formData.productId = item.id;
            this.formData.sellType = JSON.parse(item.sellType)[0];
          }
        });
      }
      this.selectProductGetData();
    },
    // 选择产品后初始化数据
    async selectProductGetData() {
      await this.getGradeAddition();
      this.$http({
        url: '/buz/molProductBase/getAdditionalProduct',
        type: 'GET',
        data: {
          productCode: this.formData.productCode
        }
      }).then(res => {
        this.additionalList = res.data;
        this.formDynamic.additional.forEach(item => {
          const bean = this.additionalList.find(item2 => item2.productId == item.productId);
          if (bean) {
            item.gradeCode = bean.code;
          }
        });
        if (this.additionalList && this.additionalList.length) {
          this.getProductGrade(this.formData.productCode, false);
        }
      });
    },
    // 获取产品档次
    getGradeAddition() {
      if (!this.formData.productCode) {
        return;
      }
      return this.$http({
        url: '/buz/gradeAddition/read/list',
        type: 'get',
        data: {
          productCode: this.formData.productCode
        }
      }).then(res => {
        const list = res.data;
        if (list && list.length == 1) {
          this.formData.gradeCode = list[0].gradeCode;
          this.getProductGrade(this.formData.productCode, true);
        }
        this.gradeAdditionList = list;
      });
    },
    // 选择产品档次
    selectGradeAddition() {
      this.getProductGrade(this.formData.productCode, true);
    },
    // 产品档次列表
    getProductGrade(code, isMain) {
      let params = {
        productCode: code,
        isMain
      };
      if (isMain) {
        //主险
        this.gradeList = [];
        params.gradeCode = this.formData.gradeCode;
      } else {
        //附加险
        this.additionGradeList = [];
      }
      if (!code) {
        return;
      }
      this.$http({
        url: '/buz/programBase/queryAllProductGrade',
        type: 'post',
        data: params
      }).then(res => {
        if (isMain) {
          this.gradeList = res.data;
        } else {
          this.additionGradeList = res.data;
        }
      });
    },
    // 选择方案
    selectGrade(data, formData, isMain) {
      if (!data) {
        return;
      }
      if (isMain) {
        data = this.gradeList.find(item => {
          return item.programId == data.value;
        });
      } else {
        data = this.additionGradeList.find(item => {
          return item.programId == data.value;
        });
      }
      formData.payType = data.payType || '1';
      formData.programName = data.programName || '';
      formData.payLimit = data.payTerm;
      formData.payment = data.payPerm;
      formData.guaranteeLimit = data.guaranteeValue;
      formData.guaranteeType = data.guaranteeType || '3';
      formData.insuredAmount = data.insuredAmount || '';
      formData.includingDeath = data.includingDeath;
    },
    // 获取禁用的附加险
    getDiabledAddition() {
      this.disabledAdditional = [];
      this.formDynamic.additional.map((item, index) => {
        if (item.productId) {
          this.disabledAdditional.push(item.productId);
        }
      });
    },
    // 选择保司
    selectCompany(company) {
      if (!company || !this.formData.companyCode) {
        return;
      }
      this.companyList.map(item => {
        if (item && item.code == company.value) {
          this.formData.companyId = item.companyId;
          this.formData.companyName = item.fullName;
        }
      });
      this.formData.productCode = '';
      this.formData.programId = '';
      this.formData.payType = '';
      this.formData.payLimit = '';
      this.formData.guaranteeLimit = '';
      this.formData.guaranteeType = '3';
      this.getProductList();
    },
    // 产品列表
    getProductList() {
      return this.$http({
        url: '/buz/productBase/read/short/list',
        type: 'post',
        data: {
          pageNo: 1,
          pageSize: 9999,
          companyCode: this.formData.companyCode
        }
      }).then(res => {
        this.productListArr = res.data;
        this.$nextTick(() => {
          const product = this.productListArr.find(item => item.productCode == this.formData.productCode)
          if (product) {
            this.productInfo = product
          }
        })
      });
    },
    // 选择出单业务员
    async selectSalesMan(id) {
      const userList = this.$refs.salesmanSelect.list;
      const bean = userList.find(item => {
        return item.id == id;
      });
      if (bean) {
        this.formData.salesmanName = bean.name;
        this.formData.groupId = bean.groupId;
        this.formData.orgId = bean.organizationId;
        this.formData.orgName = bean.organizationName;
      } else {
        this.formData.salesmanName = '';
      }
      if (this.editFlag == 'add' || this.editFlag == 'copy') {
        const list = await this.getOrgUserList(id);
        if (list && list.length > 0) {
          this.$set(this.formData, 'serviceAgent', list[0].id);
        }
      }
    },
    // 校验被保人
    async validateInsure() {
      let insuredFormValidArr = [];
      for (let i = 0; i < this.insuredFormDynamic.insuredForm.length; i++) {
        let insuredFormValid = await this.$refs[`insuredFormRef${i}`][0].validate().catch(err => {
          return err;
        });
        insuredFormValidArr.push(insuredFormValid);
      }
      return insuredFormValidArr;
    },
    // 校验保障权益
    async validateRights() {
      let rightsFormValidArr = [];
      for (let i = 0; i < this.insuredFormDynamic.insuredForm.length; i++) {
        for (let r = 0; r < this.insuredFormDynamic.insuredForm[i].rights1.length; r++) {
          let rightFormValid = await this.$refs[`rightsRef${i}${r}`][0].validate().catch(err => {
            return err;
          });
          rightsFormValidArr.push(rightFormValid);
        }
      }
      return rightsFormValidArr;
    },
    // 校验受益人
    async validateBenefit() {
      // 校验受益人
      let benefitvalid = [];
      for (let i = 0; i < this.benefitFormDynamic.benefitForm.length; i++) {
        let valids = await this.$refs[`benefitFormRef${i}`][0].validate().catch(err => {
          return err;
        });
        benefitvalid.push(valids);
      }
      return benefitvalid;
    },
    // 校验附加险
    async validateDddtional() {
      let addtionalArr = [];
      for (let i = 0; i < this.formDynamic.additional.length; i++) {
        let valids1 = await this.$refs[`additionalForm${i}`][0].validate().catch(err => {
          return err;
        });
        addtionalArr.push(valids1);
      }
      return addtionalArr;
    },
    changeStatus(val) {
      // 清空校验状态，防止校验信息错位
      this.$refs.formInline.fields.forEach((v, i) => {
        v.validateDisabled = true;
        v.validateState = '';
        v.validateMessage = '';
      });
      if (this.formData.status == '-1') {
        if (this.formData.mainFee && !this.formData.refundFee) {
          this.formData.refundFee = this.formData.mainFee;
        }
      } else {
        this.formData.refundFee = '';
        this.formData.reason = '';
        this.formData.returnTime = '';
      }
    },
    changeStatus2(form) {
      if (form.status == '-1') {
        if (form.fee && !form.refundFee) {
          form.refundFee = form.fee;
        }
      } else {
        form.refundFee = '';
        form.reason = '';
        form.returnTime = '';
      }
    },
    // 校验
    async yz() {
      let benefitvalid = [];
      let addtionalArr = [];
      let insuredFormValidArr = [];
      let validateRightsArr = [];
      // 如果受益人为法定受益人 1，清空受益人信息列表
      if (this.beneficiaryType == 1) {
        this.benefitFormDynamic.benefitForm = [
          {
            name: '', // 受益人姓名
            insuranceRelation: '', // 与被保险人关系
            idType: '', // 受益人证件类型
            idNo: '', //受益人证件号
            sex: '', //受益人性别
            birth: '', //受益人出生日期
            benefitScale: '', // 受益比例
            benefitOrder: '' // 收益顺序
          }
        ];
      } else if (this.beneficiaryType == 2 && this.formData.isAbnormal == '0') {
        // 校验受益人表单
        benefitvalid = await this.validateBenefit();
        let sumMap = {};
        this.benefitFormDynamic.benefitForm.forEach(item => {
          if (sumMap[item.benefitOrder]) {
            sumMap[item.benefitOrder] += item.benefitScale * 1;
          } else {
            sumMap[item.benefitOrder] = item.benefitScale * 1;
          }
        });
        for (const key in sumMap) {
          if (Object.hasOwnProperty.call(sumMap, key)) {
            if (sumMap[key] != 100) {
              this.$notice.msg('同顺序受益比例之和必须为100%');
              return false;
            }
          }
        }
      }
      //有附加险才校验附加险
      if (this.formDynamic.additional.length > 0) {
        addtionalArr = await this.validateDddtional();
      }
      //校验被保人 ------
      insuredFormValidArr = await this.validateInsure();
      // 校验保障权益
      validateRightsArr = await this.validateRights();
      // 校验基础信息
      let form1 = await this.$refs.formInline.validate().catch(err => {
        return err;
      });
      console.log('form1校验基础信息', form1);
      //校验投保人
      let form2 = await this.$refs.policyHoderref.validate().catch(err => {
        return err;
      });
      console.log('form2校验投保人', form2);
      //校验被保人
      let form3 = await !insuredFormValidArr.includes(false);
      console.log('form3校验被保人', form3);
      //校验保障权益
      let form6 = await !validateRightsArr.includes(false);
      console.log('form6校验保障权益', form6);
      // 校验受益人
      let form4 = await !benefitvalid.includes(false);
      console.log('form4校验受益人', form4);
      // 校验附加险
      let form5 = await !addtionalArr.includes(false);
      console.log('form5校验附加险', form5);
      let isAll = [];
      // 没有附加险不校验附加险
      if (this.formDynamic.additional.length > 0) {
        isAll = [form1, form2, form3, form4, form5, form6];
      } else {
        isAll = [form1, form2, form3, form4, form6];
      }
      return !isAll.includes(false);
    },
    // 保单录入
    async addPolicy(isDraft) {
      if (!isDraft) {
        if (!this.hasAddition && this.formDynamic.additional.length) {
          this.$notice.msg('产品缺失附加险');
          return false;
        }
        const isOk = await this.yz();
        if (!isOk) {
          window.scrollTo(0, 0);
          this.$notice.msg('请将必填项填写完整');
          return;
        }
      }
      if (this.beneficiaryType == '1') {
        // 如果受益人为法定受益人 1，清空受益人信息列表
        this.benefitFormDynamic.benefitForm = [
          {
            name: '', // 受益人姓名
            insuranceRelation: '', // 与被保险人关系
            idType: '', // 受益人证件类型
            idNo: '', //受益人证件号
            sex: '', //受益人性别
            birth: '', //受益人出生日期
            benefitScale: '', // 受益比例
            benefitOrder: '' // 收益顺序
          }
        ];
      }
      // 投保资料
      let insuranceInfoList = this.insuranceInfoList.map(item => {
        if (item) {
          return item.url;
        }
      });
      // 保险合同
      let insuranceContractList = this.insuranceContractList.map(item => {
        if (item) {
          return item.url;
        }
      });
      // 客户告知书
      let customerNoticeList = this.customerNoticeList.map(item => {
        if (item) {
          return item.url;
        }
      });
      // 其他
      let otherInfoList = this.otherInfoList.map(item => {
        if (item) {
          return item.url;
        }
      });
      // 处理被保人信息 ----
      const insuredForm = JSON.parse(JSON.stringify(this.insuredFormDynamic.insuredForm));
      insuredForm.map(item => {
        item.regionCode = item.regionCode.join('-');
        if (item.lifelong) {
          item.validPeriod = '终身';
          item.cardStartDate = item.cardStartDate || '';
        } else if (item.term.length == 2) {
          item.cardStartDate = this.$units.formatDate(item.term[0]);
          item.validPeriod = this.$units.formatDate(item.term[1]);
        }
      });

      if (this.oldMobile == this.policyHoderForm.holderMobile) {
        delete this.policyHoderForm.holderMobile;
      }
      if (this.oldIdNo == this.policyHoderForm.holderIdNo) {
        delete this.policyHoderForm.holderIdNo;
      }
      // 处理区域数据
      let baseInfo = JSON.parse(JSON.stringify(this.formData));

      // 主险+ 附加险
      let additional = JSON.parse(JSON.stringify(this.formDynamic.additional));
      let productList = [
        {
          offlineId: baseInfo.offlineId, //保单id
          productId: baseInfo.productId, //产品id
          programId: baseInfo.programId, //方案id
          programName: baseInfo.programName, //方案
          productCode: baseInfo.productCode, //产品code
          productName: baseInfo.productName, //产品名称
          insuranceCategory: '', //产品类型1人身险2财险3车险
          payNumber: baseInfo.payNumber, //保单年度
          status: baseInfo.status, //保单状态1已承保-1已退保0已终止
          payType: baseInfo.payType, //交费方式1年交2季交3月交4日交5半年交6岁交72月交
          payLimit: baseInfo.payLimit, //交费期限
          payment: baseInfo.payment, //交费期限
          guaranteeType: baseInfo.guaranteeType, //保障类型1终身2岁3年4月5天
          guaranteeLimit: baseInfo.guaranteeLimit, //保障期限
          fee: baseInfo.fee, //保费
          mainFee: baseInfo.mainFee, //保费
          insuredAmount: baseInfo.insuredAmount, //保额
          includingDeath: baseInfo.includingDeath //是否含身故
        },
        ...additional
      ];
      // 趸交转换为交1年
      productList.forEach(item => {
        if (item.payType == '7') {
          item.payType = 1;
          item.payLimit = 1;
        }
      });
      // 处理被保人权益
      insuredForm.map(item => {
        item.rights = JSON.stringify(item.rights1);
      });

      let params = {
        id: this.editFlag == 'edit' ? this.$route.query.id : '', //编号
        isAbnormal: this.formData.isAbnormal, // 类型
        remark: this.formData.remark, //备注
        cause: this.formData.cause, // 异常原因
        entrance: 2, //1、线上 2、商户端录入 3、运营后台录入
        recordMode: isDraft ? 2 : 1, // 录单模式：1普通单2异常单
        policyDraftId: this.draftId || this.formData.policyDraftId, // 草稿id,异常单id
        companyCode: this.formData.companyCode, // 保司code
        companyId: this.formData.companyId, //保司id(必须)
        companyName: this.formData.companyName, //保司名称(必须)
        policyNo: this.formData.policyNo, //保单号(必须)
        proposalNo: this.formData.proposalNo, //投保单号(非必须)
        orgId: this.formData.orgId, //出单机构(必须)
        orgName: this.formData.orgName, //机构名称(必须)
        salesmanId: this.formData.salesmanId, //出单业务员(必须)
        salesmanName: this.formData.salesmanName, //业务员姓名
        groupId: this.formData.groupId, //团队id
        groupName: this.formData.groupName, //团队名字
        holdTime: this.formData.holdTime, // 投保时间
        payTime: this.formData.payTime || this.formData.holdTime, // 支付时间
        insureTime: this.formData.insureTime, //承保日期
        effectTime: this.formData.effectTime, //生效日期
        hesitateTime: this.formData.hesitateTime, //犹豫期截止日
        returnTime: this.formData.returnTime, //退保日期
        refundFee: this.formData.refundFee, //退保保费
        area: this.formData.area, // 区域
        areaCode: this.formData.areaCode.join(','), // 区域
        reason: this.formData.reason, //退保原因
        endTime: this.formData.endTime, //终止日期
        verifyTime: this.formData.verifyTime, //回访日期
        receiptDate: this.formData.receiptDate, //回执日期
        receiptDate2: this.formData.receiptDate2, //回执签收日期
        verifyStatus: this.formData.verifyStatus, //回访状态0等待回访1回访成功2回访失败3无需回访
        receiptStatus: this.formData.receiptStatus, //回执状态-1无需回执0未回执1回执成功2回执失败
        holderId: this.policyHoderForm.holderId, //投保人
        holderName: this.policyHoderForm.holderName, //投保人姓名
        holderIdType: this.policyHoderForm.holderIdType, //投保人证件类型01身份证02护照03军人证99其它06户口本04出生证
        holderIdNo: this.policyHoderForm.holderIdNo, //投保人证件号码
        holderSex: this.policyHoderForm.holderSex, //投保人性别1男2女
        holderBirth: this.policyHoderForm.holderBirth, //投保人出生日期
        holderIncome: this.policyHoderForm.holderIncome, //投保人收入
        holderMobile: this.policyHoderForm.holderMobile, //投保人电话
        holderEmail: this.policyHoderForm.holderEmail, //投保人邮箱
        holderJob: this.policyHoderForm.holderJob, //投保人职业
        holderAddress: this.policyHoderForm.holderAddress, //投保人地址
        region: this.policyHoderForm.region, //联系地址
        regionCode: this.policyHoderForm.regionCode.join('-'), //联系地址code
        height: this.policyHoderForm.height, //身高
        weight: this.policyHoderForm.weight, //体重
        hasSocialInsurance: this.policyHoderForm.hasSocialInsurance, //有无社保
        familyRelationShip: this.policyHoderForm.familyRelationShip, //家庭关系
        insuranceList: insuredForm, //被保人
        productList: productList, // 产品列表（主险+附加险）
        beneficiaryType: this.beneficiaryType, //受益人类型1法定2指定
        beneficiaryList: this.benefitFormDynamic.benefitForm, //受益人信息
        bank: this.accountForm.bank, //开户行
        cardNoName: this.accountForm.cardNoName, //银行卡户名
        cardNo: this.accountForm.account, //银行账号
        insuranceInfoList: insuranceInfoList, //投保资料列表
        insuranceContractList: insuranceContractList, // 保险合同列表
        customerNoticeList: customerNoticeList, //
        otherInfoList: otherInfoList,
        merId: '', //商户id
        cause: this.formData.cause, //异常原因
        gradeCode: this.formData.gradeCode, //档次/计划
        // delFlag:'',//删除标识
        doubleRecordStatus: this.formData.doubleRecordStatus, //双录状态
        isSelfHold: this.formData.isSelfHold, //是否自保件
        isMutualHold: this.formData.isMutualHold, //是否互保件
        sellType: this.formData.sellType, //业务类型
        sellResource: this.formData.sellResource, //业务来源
        helpUserId: this.formData.helpUserId, //协同人id
        enterUserId: this.formData.enterUserId, //录单人
        serviceAgent: this.formData.serviceAgent //服务代理人
      };
      //投保人证件有效期
      if (this.policyHoderForm.lifelong) {
        params.holderValidPeriod = '终身';
        params.holderIdStartDate = this.policyHoderForm.holderIdStartDate || '';
      } else if (this.policyHoderForm.term.length == 2) {
        params.holderIdStartDate = this.$units.formatDate(this.policyHoderForm.term[0]);
        params.holderValidPeriod = this.$units.formatDate(this.policyHoderForm.term[1]);
      }
      // 保障类型单位提示
      if (this.formData.isAbnormal === '0') {
        if (!params.productList[0].guaranteeType) {
          this.$notice.msg('请选择保障类型（保天，保年，保岁，保终身）');
          return;
        }
      }
      let url = '';
      if (isDraft) {
        //草稿
        url = '/buz/policyDraft/save';
        this.submit(url, params, isDraft);
      } else if (this.editFlag == 'add' || this.editFlag == 'copy' || this.isDraft) {
        if (this.formData.isAbnormal === '0') {
          url = '/buz/offlinePolicy/mechan/addEnterPolicy';
          this.submit(url, params, isDraft);
        } else {
          url = '/buz/policyAbnormal/save';
          this.submit(url, params, isDraft);
        }

        delete params.id;
      } else if (this.editFlag == 'edit') {
        if (this.formData.isAbnormal === '0') {
          // 判断是否已结算，如果已结算判断是否需要重新生成费用
          if (this.$route.query.type) {
            url = '/buz/offlinePolicy/mechan/addEnterPolicy';
            delete params.id;
          } else {
            url = '/buz/offlinePolicy/mechan/editEnterPolicy';
          }
          if (this.formData.settlementStatus == '1') {
            this.$Modal.confirm(
              {
                title: `是否重新生成费用？`,
                onOk: async () => {
                  params.isAgainCommissionLog = 1;
                  await this.submit(url, params, isDraft);
                },
                onCancel: async () => {
                  params.isAgainCommissionLog = 0;
                  await this.submit(url, params, isDraft);
                }
              },
              ['是', '否']
            );
          } else {
            this.submit(url, params, isDraft);
          }
        } else {
          url = '/buz/policyAbnormal/update';
          this.submit(url, params, isDraft);
        }
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
    },
    submit(url, params, isDraft) {
      this.$http({
        url: url,
        type: 'post',
        data: params,
        apiPermissionCode: 'order_30_2'
      })
        .then(res => {
          this.loading = false;
          this.mobileEye = true;
          this.accountEye = true;
          if (res.httpCode == 1) {
            if (this.editFlag == 'add' || (this.isDraft && !isDraft)) {
              this.$notice.success('新增成功');
            } else if (this.editFlag == 'edit') {
              this.$notice.success('编辑成功');
            }
            if (this.$route.query.workName == 'workName') {
              this.back('/workbench/index');
            } else {
              if (isDraft) {
                this.back('/orderManage/insuredOrder/draftList');
              } else {
                this.back('/orderManage/insuredOrder/main');
              }
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    // 选择附加险
    selectAdditionInfo(val, m, form) {
      this.getDiabledAddition();
      if (val && val.value) {
        form.programId = '';
        form.programName = '';
        const additional = this.additionalList.find(item => item.productId == val.value);
        form.gradeCode = additional.code;
        form.productId = additional.productId;
        form.productName = additional.productName;
      } else {
        form.gradeCode = '';
        form.productId = '';
        form.productName = '';
      }
    },
    //附加险新增
    handleAddition() {
      let paramsObject = {
        productId: '', // 产品id
        productName: '', // 产品名称
        programId: '', // 产品方案id
        programName: '', // 产品方案
        fee: '', // 保费
        status: '', // 保单状态
        payType: '1', //交费方式
        payLimit: '', //交费期限
        payment: '1', //交费期限单位
        guaranteeLimit: '', //保障期限
        guaranteeType: '3', //保障期限单位
        payNumber: '1', //保单年度
        insuredAmount: '' //保额
      };
      this.formDynamic.additional.push(paramsObject);
    },
    //删除附加险
    handleRemoveAddition() {
      this.formDynamic.additional.pop();
      this.getDiabledAddition();
    },
    // 添加受益人
    handleAddBenefit() {
      let paramsObject = {
        name: '', // 受益人姓名
        insuranceRelation: '', // 与被保险人关系
        idType: '', // 受益人证件类型
        idNo: '', //受益人证件号
        sex: '', //受益人性别
        birth: '', //受益人出生日期
        benefitScale: '', // 受益比例
        benefitOrder: '' // 收益顺序
      };
      this.benefitFormDynamic.benefitForm.push(paramsObject);
    },
    //删除受益人
    handleDeleteBenefit() {
      if (this.benefitFormDynamic.benefitForm.length == 1) {
        this.$Message.error('至少填写一个受益人');
      } else {
        this.benefitFormDynamic.benefitForm.pop();
      }
    },
    // 添加权益信息
    handleAddRight(rights) {
      let obj = {
        name: '',
        content: '',
        quota: ''
      };
      rights.push(obj);
    },
    // 删除权益信息
    handleDeleteRight(rights) {
      rights.pop();
    },
    // 添加被保人
    handleAddInsured() {
      let paramsObject = {
        id: '', //被保险人id，
        infoType: '', //信息类型1投保人2被保险人
        name: '', // 被保险人姓名
        idType: '', // 被保险人证件类型01身份证02护照03军人证99其它06户口本04出生证
        idNo: '', // 被保险人证件号
        validPeriod: '', // 证件有效期
        sex: '', // 被保险人性别
        age: '', // 被保险人年龄
        birth: '', // 被保险人出生日期
        holderRelation: '', // //与投保人的关系1本人2父母3子女4配偶
        income: '', // 被保险人年收入
        mobile: '', // 被保险人电话
        job: '', // 被保险人职业
        email: '', // 邮箱
        address: '', // 被保险人详细地址
        bank: '', //开户行
        cardNo: '', //卡号
        createTime: '',
        updateTime: '',
        createBy: '',
        updateBy: '',
        term: '', // 有效期
        lifelong: false, // 有效期-终身
        height: '', // 身高cm
        weight: '', // 体重kg
        hasSocialInsurance: '', // 有无社保
        familyRelationShip: '', // 家庭关系
        region: '', // 联系地址
        regionCode: [], // 联系地址code
        rights1: [
          {
            name: '',
            content: '',
            quota: ''
          }
        ], // 保障权益
        rights: ''
      };
      this.insuredFormDynamic.insuredForm.push(paramsObject);
    },
    //删除被保人
    handleDeleteInsured() {
      if (this.insuredFormDynamic.insuredForm.length == 1) {
        this.$Message.error('至少一个被保人');
      } else {
        this.insuredFormDynamic.insuredForm.pop();
      }
    },
    // 保单详情
    getPolicyDetail(policyNo, id, type) {
      this.loading = true;
      let url = '';
      let params = '';
      if (this.isDraft) {
        url = '/buz/policyDraft/read/detail';
        params = {
          id: this.draftId
        };
      } else {
        if (type != 'anomaly') {
          url = '/buz/offlinePolicy/detail';
          if (this.editFlag == 'copy') {
            params = {
              policyNo: policyNo,
              type: 2,
              isCopy: 1
            };
          } else {
            params = {
              policyNo: policyNo,
              type: 2
            };
          }
        } else {
          url = '/buz/policyAbnormal/read/detail';
          params = {
            id: id
          };
        }
      }
      this.$http({
        url: url,
        type: 'get',
        data: params
      })
        .then(res => {
          this.loading = false;
          let isAbnormal = res.data.isAbnormal ? String(res.data.isAbnormal) : this.formData.isAbnormal;

          if (this.isDraft || this.isAbnormal == 'anomaly') {
            res.data.dto.serviceAgent = res.data.serviceAgent;
            res.data.dto.serviceAgentStaffNo = res.data.serviceAgentStaffNo;
            res.data.dto.serviceAgentName = res.data.serviceAgentName;
            res.data = res.data.dto;
          }

          let productList = JSON.parse(JSON.stringify(res.data.productList));
          productList.forEach(item => {
            if (item.payment) {
              item.payment = item.payment == 4 ? '1' : item.payment.toString(); //趸交类型转为年交
            } else {
              item.payment = '';
            }
          });

          //基础信息
          this.formData = {
            isAbnormal: isAbnormal, // 类型
            cause: res.data.cause, // 异常原因
            remark: res.data.remark, //备注
            policyDraftId: res.data.policyDraftId,
            companyName: res.data.companyName, // 保险公司
            companyCode: res.data?.companyCode, // 保司code
            companyId: res.data.companyId, // 保险公司
            productId: productList[0].productId, // 产品Id
            programId: productList[0].programId, // 产品方案Id
            gradeCode: res.data.gradeCode, // 档次/计划
            programName: productList[0].programName, // 产品方案
            productCode: productList[0].productCode, // 产品Code
            source: res.data.source, //产品来源
            insuranceCategory: productList[0].insuranceCategory, //保险类别1：人身险；2：财险；3：车险
            productName: productList[0].productName, //产品名称
            fee: productList[0].fee, // 总保费(元)
            mainFee: productList[0].mainFee, // 保费(元)
            policyNo: this.editFlag == 'copy' ? '' : res.data.policyNo, // 保单号
            proposalNo: this.editFlag == 'copy' ? '' : res.data.proposalNo,
            payNumber: productList[0].payNumber, // 保单年度
            insuredAmount: productList[0].insuredAmount, // 保额
            enterUserId: res.data.enterUserId, // 录单人员id
            enterUserName: res.data.enterUserName, // 录单人员
            orgId: res.data.orgId, // 出单机构id
            groupId: res.data.groupId, // 团队id
            groupName: res.data.groupName, // 团队名字
            orgName: res.data.orgName, // 出单机构名称
            salesmanId: res.data.salesmanId, // 业务员id
            salesmanName: res.data.salesmanName, // 业务员名称
            status: productList[0].status, // 保单状态
            settlementStatus: res.data.settlementStatus, //结算状态
            insureTime: res.data.insureTime, // 承保日期
            reason: res.data.reason, // 退保原因
            verifyTime: res.data.verifyTime, // 回访日期
            verifyStatus: res.data.verifyStatus, // 回访状态
            effectTime: res.data.effectTime, // 生效日期
            hesitateTime: res.data.hesitateTime, // 犹豫期截止日
            holdTime: res.data.holdTime, // 投保时间
            payTime: res.data.payTime, // 支付时间
            receiptStatus: res.data.receiptStatus, // 回执回销状态
            receiptDate: res.data.receiptDate, // 回执回销日期
            receiptDate2: res.data.receiptDate2, // 回执签收日期
            returnTime: res.data.returnTime, // 退保日期
            refundFee: res.data.refundFee, // 退保保费
            endTime: res.data.endTime, // 终止日期
            includingDeath: productList[0].includingDeath, // 是否含身故
            payType: productList[0].payType, // 交费方式
            payLimit: productList[0].payLimit, // 交费期限数字
            payment: this.numberToString(productList[0].payment), // 交费期限单位
            guaranteeLimit: productList[0].guaranteeLimit, // 保障期限
            guaranteeType: productList[0].guaranteeType, // 保障期限时间单位
            areaCode: res.data.areaCode ? [res.data.areaCode] : [], // 区域
            area: res.data.area,
            doubleRecordStatus: this.numberToString(res.data.doubleRecordStatus), // 双录状态
            isSelfHold: res.data.isSelfHold, // 是否自保件
            isMutualHold: res.data.isMutualHold, // 是否互保件
            sellType: this.numberToString(res.data.sellType), // 业务类型
            sellResource: this.numberToString(res.data.sellResource), // 业务来源
            serviceAgent: res.data.serviceAgent, //
            serviceAgentName: res.data.serviceAgentName, //
            serviceAgentStaffNo: res.data.serviceAgentStaffNo, //
            helpUserId: res.data.helpUserId // 协同人id
          };
          if (res.data.area) {
            this.showAreaText = true;
          }
          //附加险
          if (productList.length > 1) {
            productList.shift();
            this.formDynamic.additional = productList;
          } else {
            // 无附加险不显示附加险信息
            this.hasAddition = false;
          }

          //投保人
          const policyHoderForm = res.data;
          if (res.data.holderValidPeriod == '终身') {
            policyHoderForm.term = []; // 有效期
            policyHoderForm.holderIdStartDate = res.data.holderIdStartDate || '';
          } else if (res.data.holderValidPeriod && res.data.holderIdStartDate) {
            policyHoderForm.term = [res.data.holderIdStartDate, res.data.holderValidPeriod]; // 有效期
          } else {
            policyHoderForm.term = [];
          }
          policyHoderForm.lifelong = res.data.holderValidPeriod == '终身' ? true : false; // 终身
          if (policyHoderForm.regionCode) {
            policyHoderForm.showAreaText = true;
            policyHoderForm.regionCode = res.data.regionCode.split('-');
          } else {
            policyHoderForm.regionCode = [];
          }
          policyHoderForm.familyRelationShip = this.numberToString(policyHoderForm.familyRelationShip);
          policyHoderForm.height = policyHoderForm.height || '';
          policyHoderForm.weight = policyHoderForm.weight || '';
          policyHoderForm.holderId = this.editFlag == 'copy' ? '' : policyHoderForm.holderId;
          this.policyHoderForm = policyHoderForm;
          // 被保险人
          const insuredForm = res.data.insuranceList;
          insuredForm.forEach(item => {
            item.id = this.editFlag == 'copy' ? '' : item.id;
            item.orderNo = this.editFlag == 'copy' ? '' : res.data.orderNo;
            item.familyRelationShip = this.numberToString(item.familyRelationShip);
            item.height = item.height || '';
            item.weight = item.weight || '';
            if (item.validPeriod == '终身') {
              item.term = [];
              this.$set(item, 'lifelong', true);
              item.cardStartDate = item.cardStartDate || '';
            } else if (item.cardStartDate && item.validPeriod) {
              item.term = [item.cardStartDate, item.validPeriod];
              this.$set(item, 'lifelong', false);
            } else {
              item.term = [];
              this.$set(item, 'lifelong', false);
            }
            if (item.region) {
              item.showAreaText = true;
              item.regionCode = item.regionCode.split('-');
            } else {
              item.regionCode = [];
            }
            // 权益信息处理
            if (item.rights) {
              // item.rights1 = JSON.parse(item.rights);
              this.$set(item, 'rights1', JSON.parse(item.rights));
            } else {
              this.$set(item, 'rights1', [
                {
                  name: '',
                  content: '',
                  quota: ''
                }
              ]);
            }
          });
          // this.insuredFormDynamic.insuredForm = insuredForm;
          this.$set(this.insuredFormDynamic, 'insuredForm', insuredForm);
          // 受益人
          this.beneficiaryType = res.data.beneficiaryType;
          if (res.data.beneficiaryList && res.data.beneficiaryList.length > 0) {
            const beneficiaryList = res.data.beneficiaryList;
            beneficiaryList.forEach(item => {
              item.id = this.editFlag == 'copy' ? '' : item.id;
              item.orderNo = this.editFlag == 'copy' ? '' : res.data.orderNo;
            });
            this.benefitFormDynamic.benefitForm = beneficiaryList;
          }
          //开户行
          this.accountForm = {
            bank: res.data.bank || '', //开户行
            cardNoName: res.data.cardNoName || '', //户名
            account: res.data.cardNo || '', //银行账户
            account1: res.data.cardNo1 || '',
            orderNo: res.data.orderNo
          };
          // 影像资料回显处理
          this.insuranceInfoList = [];
          this.insuranceContractList = [];
          this.customerNoticeList = [];
          this.otherInfoList = [];
          const map = new Map([
            [this.insuranceInfoList, res.data.insuranceInfoList],
            [this.insuranceContractList, res.data.insuranceContractList],
            [this.customerNoticeList, res.data.customerNoticeList],
            [this.otherInfoList, res.data.otherInfoList]
          ]);
          for (let [key, value] of map) {
            if (value) {
              value.forEach(item => {
                const isImage = this.isImage(item);
                if (isImage) {
                  key.push({
                    url: item,
                    type: 'image',
                    show: false
                  });
                } else {
                  key.push({
                    url: item,
                    type: 'pdf',
                    show: false
                  });
                }
              });
            }
          }
          this.$nextTick(async () => {
            this.getDiabledAddition(); // 获取禁用的附加险
            // this.selectCompany({});// 获取保司的产品
            await this.getProductList();
            this.getProductGrade(this.formData.productCode, true); //获取主险产品方案
            this.selectProductGetData(); // 获取附加险
            this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
            this.$refs.selectTreeRef1 && this.$refs.selectTreeRef1.openChange();
            setTimeout(() => {
              this.formData.salesmanId = res.data.salesmanId;
              this.yz();
            }, 1000);
          });
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    // 地址同投保人
    addressSameAsPH(insureds) {
      if (!this.policyHoderForm.holderAddress.includes('*') && !insureds.address.includes('*')) {
        insureds.region = this.policyHoderForm.region;
        insureds.regionCode = this.policyHoderForm.regionCode;
        insureds.address = this.policyHoderForm.holderAddress;
        this.oldAddress1 = '';
        this.addressEye1 = false;
      } else {
        this.$notice.msg('请先解密投保人地址及被保人地址');
      }
    },
    // 受益人同投保人
    benefitSameAsPH() {
      this.benefitFormDynamic.benefitForm[0].name = this.policyHoderForm.holderName;
      this.benefitFormDynamic.benefitForm[0].idType = this.policyHoderForm.holderIdType;
      this.benefitFormDynamic.benefitForm[0].idNo = this.policyHoderForm.holderIdNo;
      this.benefitFormDynamic.benefitForm[0].sex = this.policyHoderForm.holderSex;
      this.benefitFormDynamic.benefitForm[0].birth = this.policyHoderForm.holderBirth;
    },
    themeClick(index) {
      this.themeActive = index;
      if (index == 0) {
        this.uploadList = 'insuranceContractList';
      } else if (index == 1) {
        this.uploadList = 'insuranceInfoList';
      } else if (index == 2) {
        this.uploadList = 'customerNoticeList';
      } else if (index == 3) {
        this.uploadList = 'otherInfoList';
      }
    },
    // 是否是图片
    isImage(url) {
      return /\.(png|jpg|jpeg)$/.test(url.toLowerCase());
    },
    handleSuccess(res, file) {
      if (res.httpCode == 1) {
        res.data.map((item, index) => {
          let url = item.path;
          let isImage = this.isImage(url);
          let type = isImage ? 'image' : 'pdf';
          this[this.uploadList].push({
            url,
            type,
            show: false
          });
        });
      }
    },
    // 根据生日计算年龄 只有被保人有
    birthChange(data, birth) {
      const age = Math.floor(dayjs.duration(dayjs() - dayjs(birth)).asDays() / 365);
      this.$set(data, 'age', age);
      this.$set(data, 'birth', birth);
    },
    // 身份证信息截取
    idcardChange(e, data, isHolder, val, b) {
      if (val == 1) {
        this.oldIdNoe = '';
        this.$set(data, 'holderIdNo', e.target.value);
        this.idEye = false;
        this.insuredFormDynamic.insuredForm.forEach((item, index) => {
          if (item.holderRelation == 1) {
            item.idNo = e.target.value;
            item['idEye' + index] = true;
          }
        });
      } else if (val == 2) {
        data['oldIdNo' + b] = '';
        this.$set(data, 'idNo', e.target.value);
        data['idEye' + b] = true;
      } else if (val == 3) {
        data['idEye' + b] = true;
        data['oldIdNo' + b] = '';
        this.$set(data, 'idNo', e.target.value);
      }

      let type, idNo;
      if (isHolder) {
        //投保人
        type = data.holderIdType;
        idNo = data.holderIdNo;
      } else {
        //被保人
        type = data.idType;
        idNo = data.idNo;
      }
      var pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if ((type == 1 || type == 6 || type == '') && idNo && pattern.test(idNo)) {
        const birthday = idNo.substr(6, 4) + '-' + idNo.substr(10, 2) + '-' + idNo.substr(12, 2);
        const sex = idNo.substr(16, 1) % 2 == 1 ? '1' : '2';
        const age = Math.floor(dayjs.duration(dayjs() - dayjs(birthday)).asDays() / 365);
        if (isHolder) {
          this.$set(data, 'holderBirth', birthday);
          this.$set(data, 'holderSex', sex);
        } else {
          this.$set(data, 'birth', birthday);
          this.$set(data, 'sex', sex);
          this.$set(data, 'age', age);
        }
      }
    },
    // 邮箱搜索
    emailSearch(value, data) {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        const allEmails = [
          '@qq.com',
          '@sina.com',
          '@126.com',
          '@163.com',
          '@139.com',
          '@189.cn',
          '@sohu.com',
          '@dingtalk.com',
          '@aliyun.com',
          '@hotmail.com',
          '@outlook.com',
          '@yeah.net'
        ];
        if (value && !value.includes('@')) {
          this.$set(
            data,
            'emailArr',
            allEmails.map(text => value + text)
          );
        } else if (value && value.includes('@')) {
          const key = value.substr(value.indexOf('@'));
          this.$set(
            data,
            'emailArr',
            allEmails.filter(text => text.includes(key)).map(text => value + text.replace(key, ''))
          );
        } else {
          this.$set(data, 'emailArr', []);
        }
      }, 300);
    },
    // 回执切换
    receiptStatusChange() {
      if (this.formData.receiptStatus == -1) {
        //无需回执
        this.formData.receiptDate = '';
        this.formData.receiptDate2 = '';
      }
    },
    // 显示区域下拉
    openArea() {
      this.formData.area = '';
      this.formData.areaCode = [];
      this.showAreaText = false;
    },
    // 投被保人地区选择
    regionCascader(form, key, data) {
      form[key] = data.map(item => item.label).join('');
    },
    // 打开投被保人地区选择
    openRegionCascader(form, key) {
      this.$set(form, key, []);
      this.$set(form, 'showAreaText', false);
    },
    numberToString(data) {
      return data?.toString();
    },
    // 银行卡识别
    bankChange(e, data) {
      this.oldAccount = '';
      this.accountEye = false;
      this.$set(data, 'account', e.target.value);
      if (data.account && data.account.includes(' ')) {
        this.$set(item, 'data', data.account.replace(/ /g, ''));
      }
      var pattern = /^([1-9]{1})(\d{14,18})$/;
      if (!data.account || !pattern.test(data.account)) {
        return;
      }
      this.$http({
        url: '/buz/userCertificate/queryBankByCardNo',
        type: 'GET',
        data: {
          cardNo: data.account
        }
      }).then(res => {
        if (res.data) {
          data.bank = res.data;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './addPolicy';
</style>
<style lang="scss">
.policyPoper {
  .ivu-poptip-content {
    .ivu-poptip-inner {
      .ivu-table-wrapper {
        .ivu-table {
          .ivu-table-body {
            .ivu-table-row {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

.areaStyle {
  position: absolute;
  font-size: 14px;
  color: #515a6e;
  left: -60px;
}

.areaStyle:before {
  content: '*';
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 14px;
  color: #ed4014;
}
</style>
